import i18n from '../locales';
import store from '../store';
import routeDetailModalEscl from '../locales/es-CL/routeDetailModal.json';
import routeDetailModalEsmx from '../locales/es-MX/routeDetailModal.json';
import routeDetailModalEsco from '../locales/es-CO/routeDetailModal.json';
import routeDetailModalEnus from '../locales/en-US/routeDetailModal.json';
import showAlert from '@waypoint/vue-alert';
import moment from 'moment';
import { eventBus_routeDetailModal_routeDetailMap } from '../main';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
import axios from 'axios';

export default {
  i18n: {
    messages: {
      'en-US': { routeDetailModal: routeDetailModalEnus },
      'es-CL': { routeDetailModal: routeDetailModalEscl },
      'es-MX': { routeDetailModal: routeDetailModalEsmx },
      'es-CO': { routeDetailModal: routeDetailModalEsco },
    },
  },
  data() {
    return {
      apiKey: store.getters.apiKey,
      geoFencePoints: [],
      directionsRenderer: [],
      route: null,
      routingService: 'LocationIQ',
      gapi: null,
      usePolyline: true,
      points: [],
      trips: [],
      paths: [],
      pathsLastmileV2: [],
      pathOptionsPending: {
        strokeColor: '#6226F7',
        strokeOpacity: 0,
        icons: [
          {
            icon: {
              path: 'M 0,-1 0,1',
              strokeOpacity: 1,
              scale: 4,
            },
            offset: '0',
            repeat: '20px',
          },
        ],
      },
      pathOptionsDone: {
        strokeColor: '#196984',
        strokeOpacity: 1,
      },
      routePathSimpleLastmileV2: {
        strokeColor: '#06303F',
        strokeOpacity: 1,
      },
      markers: [],
      waypointsMarkers: [],
      markersLastmileLite: [],
      googleMarkers: [],
      usingVehicleMarker: false,
      vehiclePositionMarker: [],
      actualPositionVeh: null,
      icon: {
        depots:
          'M30.5 15.416C30.5 17.4185 29.5799 19.992 28.1344 22.7749C26.6973 25.5416 24.7756 28.4511 22.8455 31.1068C20.9168 33.7606 18.9869 36.1511 17.5387 37.8786C16.8148 38.7421 16.2118 39.4393 15.7901 39.9203C15.6809 40.0448 15.5838 40.1549 15.5 40.2495C15.4162 40.1549 15.3191 40.0448 15.2099 39.9203C14.7882 39.4393 14.1852 38.7421 13.4613 37.8786C12.0131 36.1511 10.0832 33.7606 8.15446 31.1068C6.22438 28.4511 4.30269 25.5416 2.86559 22.7749C1.42008 19.992 0.5 17.4185 0.5 15.416C0.5 7.18068 7.21316 0.5 15.5 0.5C23.7868 0.5 30.5 7.18068 30.5 15.416Z',
        base: 'M10.5,0 C16.2989899,0 21,4.60773612 21,10.2916667 C21,14.0809537 17.5,19.3170648 10.5,26 C3.5,19.3170648 0,14.0809537 0,10.2916667 C0,4.60773612 4.70101013,0 10.5,0 Z M10.5,5 C8.290861,5 6.5,6.790861 6.5,9 C6.5,11.209139 8.290861,13 10.5,13 C12.709139,13 14.5,11.209139 14.5,9 C14.5,6.790861 12.709139,5 10.5,5 Z',
        trip: 'M10.5,26 C17.5,19.3170648 21,14.0809537 21,10.2916667 C21,4.60773612 16.2989899,0 10.5,0 C4.70101013,0 0,4.60773612 0,10.2916667 C0,14.0809537 3.5,19.3170648 10.5,26 Z',
      },
      iconPathArrow:
        'M20.4482 22.7296L10.2282 0L0 22.7296L1.3582 24.0896L10.2282 20.1896L19.0882 24.0896L20.4482 22.7296Z',
      iconPathCargo:
        'M20.94 11C20.48 6.83 17.17 3.52 13 3.06V1H11V3.06C6.83 3.52 3.52 6.83 3.06 11H1V13H3.06C3.52 17.17 6.83 20.48 11 20.94V23H13V20.94C17.17 20.48 20.48 17.17 20.94 13H23V11H20.94ZM12 19C8.13 19 5 15.87 5 12C5 8.13 8.13 5 12 5C15.87 5 19 8.13 19 12C19 15.87 15.87 19 12 19Z M16.5 10H15V8H8C7.45 8 7 8.45 7 9V14.5H8C8 15.33 8.67 16 9.5 16C10.33 16 11 15.33 11 14.5H14C14 15.33 14.67 16 15.5 16C16.33 16 17 15.33 17 14.5H18V12L16.5 10ZM9.5 15.25C9.085 15.25 8.75 14.915 8.75 14.5C8.75 14.085 9.085 13.75 9.5 13.75C9.915 13.75 10.25 14.085 10.25 14.5C10.25 14.915 9.915 15.25 9.5 15.25ZM16.25 10.75L17.23 12H15V10.75H16.25ZM15.5 15.25C15.085 15.25 14.75 14.915 14.75 14.5C14.75 14.085 15.085 13.75 15.5 13.75C15.915 13.75 16.25 14.085 16.25 14.5C16.25 14.915 15.915 15.25 15.5 15.25Z',
      colorIcon: {
        done: '#196984',
        pending: '#17a7d9',
      },
      colorIconLastmileV2: {
        unreacheable: '#686767',
        pending: '#AD20CE',
        done: '#04bb04',
        rejected: '#ff0000',
        partial: '#eeb71f',
        default: '#7A46FB',
        depot: '#296280',
        active: '#995FFF',
        unactive: '#5D5D5E',
        realLocation: '#0096CA',
        strokeColor: '#3E3E3E',
      },
      options: {
        gestureHandling: 'greedy',
        disableDefaultUI: false,
        streetViewControl: false,
        styles: [
          {
            featureType: 'poi',
            elementType: 'labels',
            stylers: [{ visibility: 'off' }],
          },
        ],
      },
      infoWinOpen: false,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      infoWindowPos: {
        lat: 0,
        lng: 0,
      },
      infoContent: null,
      realTimeLocationVeh: [],
      realTimeLocationCargo: [],
      realTimeLocationGpsControl: [],
      useRealTimeMarker: true,
      useRealTimeMarkerCargo: true,
      useRealTimeMarkerGpsControl: true,
      selectedSoloMarker: null,
      tries: 0,
      oms: null,
      lastOpenedInfoWindow: null,
      markerCluster: null,
      currentInfoWindow: null,
      drawnPolylines: [],
    };
  },
  async mounted() {
    const self = this;
    eventBus_routeDetailModal_routeDetailMap.$on('routeMapClicked', function (data) {
      self.route = data;
    });
  },
  methods: {
    setGeofenceVisibility(visibility) {
      if (this.geoFencePoints.length > 0) {
        this.geoFencePoints.forEach((geo) => {
          geo.setVisible(visibility);
        });
      }
      if (this.markersLastmileLite.length > 0) {
        this.markersLastmileLite.forEach((marker) => {
          if (marker.type == 'geofence') {
            marker.visible = visibility;
          }
        });
      }
    },
    async setSpotsWRouteOptimization(
      gapi,
      initBaseList,
      acitivitySpotList,
      lastBaseList,
      idRoutePairing,
      unreacheableOperations,
      temporalSpots,
      geofence,
    ) {
      this.infoWinOpen = false;
      //Listado total de marcadores
      this.markersLastmileLite = [];
      this.setMapNull();
      this.setGapi(gapi);
      //Listado de marcadores pero agrupados para utilizar la funcion de waypoints en los mapas
      let markersList = [];
      for (let i = 0; i <= idRoutePairing; i++) {
        let localRouteDraw = [];
        initBaseList.forEach((base) => {
          if (base.index === i) {
            const indexMarker = 0;
            const name = 'Base';
            const street = base.spot.extraInfo.address;
            const lat = base.spot.lat;
            const lon = base.spot.lon;
            const tempObject = this.buildMarker(
              base.index,
              indexMarker,
              name,
              street,
              lat,
              lon,
              this.colorIconLastmileV2.depot,
              false,
              null,
            );
            this.markersLastmileLite.push(tempObject);
            markersList.push(tempObject);
          }
        });

        acitivitySpotList.forEach((activity, index) => {
          if (activity.index === i) {
            const indexMarker = activity.subIndex + 1;
            const name = activity.name;
            const street = activity.spot.extraInfo.address;
            const lat = activity.spot.lat;
            const lon = activity.spot.lon;
            const color = this.markerColor(activity);
            const tempObject = this.buildMarker(
              activity.index,
              indexMarker,
              name,
              street,
              lat,
              lon,
              color,
              false,
              null,
            );
            this.markersLastmileLite.push(tempObject);
            if (localRouteDraw.length < 10) {
              const waypoint = {
                location: {
                  lat: lat,
                  lng: lon,
                },
                stopover: true,
              };
              localRouteDraw.push(waypoint);
            }
            if (localRouteDraw.length == 10 || index == acitivitySpotList.length - 1) {
              markersList[markersList.length - 1]['waypoints'] = localRouteDraw;
              markersList.push(tempObject);
              localRouteDraw = [];
            }
          }
        });
        lastBaseList.forEach((base) => {
          if (base.index === i && base.spot != null) {
            const indexMarker = 0;
            const name = 'Base';
            const street = base.spot.extraInfo.address;
            const lat = base.spot.lat;
            const lon = base.spot.lon;
            const tempObject = this.buildMarker(
              base.index,
              indexMarker,
              name,
              street,
              lat,
              lon,
              this.colorIconLastmileV2.depot,
              false,
              null,
            );
            this.markersLastmileLite.push(tempObject);
            markersList.push(tempObject);
          }
        });
      }
      if (unreacheableOperations !== null && unreacheableOperations.length > 0 && temporalSpots.length > 0) {
        unreacheableOperations.forEach((op, index) => {
          const spot = temporalSpots.find((spot) => spot.id == op.spot);
          if (spot) {
            const indexMarker = index + 1;
            const name = op.name;
            const street = [spot.address.street, spot.address.city, spot.address.state].filter(Boolean).join(', ');
            const lat = spot.address.lat;
            const lon = spot.address.lon;
            const tempObject = this.buildMarker(
              0,
              indexMarker,
              name,
              street,
              lat,
              lon,
              this.colorIconLastmileV2.unreacheable,
              false,
              null,
            );
            this.markersLastmileLite.push(tempObject);
          }
        });
      }
      const centerMap = await this.prepareMapView(true);

      await this.$refs.mapRef.$mapPromise.then((map) => {
        this.map = map;
      });
      if (geofence !== null && geofence !== undefined) {
        this.makePolygonGeofence(this.markersLastmileLite, gapi, geofence.zone, geofence.name);
      }
      //Por cada viaje, se prepara un marker en mapa.
      if (this.markersLastmileLite.length > 1) {
        let bounds = new gapi.maps.LatLngBounds();
        this.markersLastmileLite.forEach((marker) => {
          bounds.extend(new gapi.maps.LatLng(marker.position.lat, marker.position.lng));
        });
        await this.$refs.mapRef.$mapPromise.then((map) => {
          map.fitBounds(bounds);
        });
      }
      //Edito el centro del mapa
      this.map.setCenter(centerMap);
      markersList.forEach((routeTemporal, index) => {
        //Metodo que prepara el trazado del mapa entre los diferentes puntos
        this.preparePathInMapGoogle(markersList, routeTemporal, index, true);
      });
    },
    async eventMapClick(index) {
      //Si el index es -999 busco el ultimo trip/operacion que sea base del listado para centrar el mapa.
      let marker =
        index != -999
          ? this.googleMarkers.find((gMarker) => String(gMarker.index) === String(index))
          : this.googleMarkers.findLast((gMarker) => gMarker.trip.typeName === 'Base');
      await this.$refs.mapRef.$mapPromise.then(async (map) => {
        this.map = map;
        //Se hace doble evento click debido que el primer click gatilla el spiderfier
        this.gapi.maps.event.trigger(marker, 'click');
        this.gapi.maps.event.trigger(marker, 'click');
      });
      this.map.setZoom(15);
      this.map.setCenter({
        lat: marker.position.lat(),
        lng: marker.position.lng() - 0.0008,
      });
    },
    async setSpotsWRoute(
      gapi,
      initBaseList,
      acitivitySpotList,
      lastBaseList,
      idRoutePairing,
      geofence,
      vehicleLocation,
    ) {
      this.usingVehicleMarker = false;
      this.infoWinOpen = false;
      //Se encarga de limpiar el cluster si es que existe
      this.cleanCluster();
      //Limpio marcadores de google
      this.cleanMapMarkers();
      //Limpio el spiderfier
      this.cleanMarkersFromSpiderfier();
      //Limpio rendereizados en el mapa
      this.setMapNull();
      //Seteo el api como variable global
      this.setGapi(gapi);
      //Se guardan los trips de manera local.
      let pointsRender = [];
      for (let i = 0; i <= idRoutePairing; i++) {
        pointsRender = this.createMarkers(initBaseList, this.googleMarkers, pointsRender, 'Depot', i);
        pointsRender = this.createMarkers(acitivitySpotList, this.googleMarkers, pointsRender, 'Trip', i);
        pointsRender = this.createMarkers(lastBaseList, this.googleMarkers, pointsRender, 'Depot', i);
      }
      if (vehicleLocation) {
        const indexMarker = acitivitySpotList.length + 3;
        const name = vehicleLocation.plate;
        const lat = vehicleLocation.lat;
        const lon = vehicleLocation.lon;
        const hasRealLocation = false;
        //Si el marcador es bodega se pasa nulo debido a que el marcador es una imagen para las bodegas
        let colorIcon = this.markerColor(vehicleLocation);
        const initMarker = this.prepareMarker(
          indexMarker,
          lat,
          lon,
          name,
          null,
          hasRealLocation,
          null,
          'Vehicle',
          vehicleLocation.gpsData,
          null,
        );
        this.actualPositionVeh = this.setSvgMarker(
          initMarker,
          colorIcon,
          indexMarker,
          'Vehicle',
          vehicleLocation.gpsData.cog,
          vehicleLocation.state,
        );
      }

      //Se obtiene el punto central a partir de las ubicaciones de los marcadores
      const centerMap = await this.prepareMapViewGoogle(this.googleMarkers);
      await this.$refs.mapRef.$mapPromise.then(async (map) => {
        this.map = map;
        this.configureSpiderfier();
        this.map.setCenter(centerMap);
      });
      if (geofence !== null && geofence !== undefined) {
        this.makePolygonGeofence(this.markersLastmileLite, gapi, geofence.zone, geofence.name);
      }
      //Por cada viaje, se prepara un marker en mapa.
      if (this.googleMarkers.length > 1) {
        this.oms.clearMarkers();
        let bounds = new gapi.maps.LatLngBounds();
        this.googleMarkers.forEach((marker) => {
          //Setea el marcador en el mapa
          marker.setMap(this.map);
          //Cuando se clickea un marcador busca si la operación del marcador tiene registrado una ubicación donde fue ejecutada
          marker.addListener('click', () => {
            this.setMarkerRealLocationGoogle(this.googleMarkers, marker);
          });
          this.oms.addMarker(marker);
          bounds.extend(new gapi.maps.LatLng(marker.position.lat(), marker.position.lng()));
        });
        if (this.actualPositionVeh) {
          this.actualPositionVeh.setMap(this.map);
          this.oms.addMarker(this.actualPositionVeh);
          bounds.extend(
            new gapi.maps.LatLng(this.actualPositionVeh.position.lat(), this.actualPositionVeh.position.lng()),
          );
        }
        await this.$refs.mapRef.$mapPromise.then((map) => {
          map.fitBounds(bounds);
        });
      }
      pointsRender.forEach((routeTemporal, index) => {
        //Calcula el camino entre cada uno de los marcadores existentes
        this.preparePathInMapGoogle(pointsRender, routeTemporal, index, true);
      });
    },
    /**
     * Metodo que configura el Spiderfier, esto es la araña que permite visualizar marcadores solapados
     */
    configureSpiderfier() {
      const options = {
        keepSpiderfied: true,
        markersWontMove: true,
        markersWontHide: true,
        basicFormatEvents: true,
        minZoomLevel: 7,
        nudgeRadius: 0.004,
        nearbyDistance: 1,
        legWeight: 5,
        circleFootSeparation: 30,
      };
      const Spiderfier = require('overlapping-marker-spiderfier');
      this.oms = new Spiderfier(this.map, options);
      const iw = new this.gapi.maps.InfoWindow();
      this.oms.addListener('click', (marker) => {
        this.currentInfoWindow = iw;
        iw.setContent(marker.description);
        iw.open(document.getElementById('mapRef'), marker);
      });
      this.oms.addListener('spiderfy', () => {
        this.currentInfoWindow = null;
        iw.close();
      });
    },
    cleanCluster() {
      if (this.markerCluster) {
        this.markerCluster.clearMarkers(); // Elimina todos los marcadores del cluster
        this.markerCluster = null; // Elimina la referencia del cluster
      }
    },
    /**
     * Metodo que limpia los marcadores del mapa
     */
    cleanMapMarkers() {
      if (this.googleMarkers.length > 1) {
        this.googleMarkers.forEach((marker) => {
          marker.setMap(null);
        });
      }
      if (this.vehiclePositionMarker) {
        this.vehiclePositionMarker.forEach((marker) => {
          marker.setMap(null);
        });
      }
      if (this.actualPositionVeh) {
        this.actualPositionVeh.setMap(null);
      }
      this.actualPositionVeh = null;
      this.vehiclePositionMarker = [];
      this.googleMarkers = [];
    },
    cleanMarkersFromSpiderfier() {
      if (this.oms) {
        this.oms.clearMarkers();
      }
    },
    /**
     * Se encarga de preparar los servicios de dirección, dibuja en el mapa el tramo que hay entre dos puntos (Incluyendo sus waypoints)
     * @param {*} gapi referencia al api de google
     * @param {Array} markersList Listado de marcadores (Dentro de ellos pueden haber waypoints)
     * @param {Marker} routeTemporal Marcador que se va a procesar
     * @param {Integer} index Indice de la posición de routeTemporal en el array markerList
     */
    async preparePathInMap(markersList, routeTemporal, index, requireIcon = false) {
      //Configuración de los iconos del trazado
      if (index <= markersList.length - 2) {
        let waypoints = routeTemporal.waypoints || [];
        routeTemporal.trip.originAddress.lng = routeTemporal.trip.originAddress.lon;
        const origin = { location: { latLng: this.getLatLng(routeTemporal.trip.originAddress) } };
        routeTemporal.trip.destinationAddress.lng = routeTemporal.trip.destinationAddress.lon;
        const destination = { location: { latLng: this.getLatLng(routeTemporal.trip.destinationAddress) } };
        const intermediates = waypoints.map((wp) => ({
          location: { latLng: this.getLatLng(wp.location) },
        }));

        const requestBody = {
          origin,
          destination,
          intermediates,
          travelMode: 'DRIVE',
          languageCode: 'es',
          regionCode: 'CL', // o 'MX'
          computeAlternativeRoutes: false,
          routingPreference: 'TRAFFIC_AWARE',
        };
        const iconConfig = [
          {
            icon: {
              path: this.gapi.maps.SymbolPath.FORWARD_CLOSED_ARROW,
              scale: 3,
              fillOpacity: 1,
            },
            repeat: '50px',
          },
        ];
        await this.getGoogleComputeRoute(
          requestBody,
          routeTemporal.trip.routeColor,
          0.8,
          routeTemporal.trip.widthRoute,
          requireIcon ? iconConfig : null,
        );
      }
    },
    /**
     * Metodo que prepara el trazado en el mapa de google entre un origen y un destino, con multiples puntos
     * @param {*} markersList Listado de todos los puntos por los cuales debe viajar el vehiculo
     * @param {*} routeTemporal Ruta actual que debe realizar un vehiculo
     * @param {*} index
     */
    async preparePathInMapGoogle(markersList, routeTemporal, index, iconRequired = false, configStroke = null) {
      if (this.drawnPolylines && this.drawnPolylines.length > 0) {
        this.drawnPolylines.forEach((polyline) => polyline.setMap(null));
        this.drawnPolylines = [];
      }
      //Configuración de los iconos del trazado
      if (index <= markersList.length - 2) {
        let waypoints = routeTemporal.waypoints || [];
        const origin = { location: { latLng: this.getLatLng(routeTemporal.position) } };
        const destination = { location: { latLng: this.getLatLng(markersList[index + 1].position) } };
        const intermediates = waypoints.map((wp) => ({
          location: { latLng: this.getLatLng(wp.location) },
        }));
        //Configuración para construir el trazado (polyline)
        const {
          strokeColor = this.routePathSimpleLastmileV2.strokeColor,
          strokeOpacity = 1,
          strokeWeight = 6,
        } = configStroke || {};
        //Request body para el endpoint de calcular la ruta
        const requestBody = {
          origin,
          destination,
          intermediates,
          travelMode: 'DRIVE',
          languageCode: 'es',
          regionCode: 'CL', // o 'MX'
          computeAlternativeRoutes: false,
          routingPreference: 'TRAFFIC_AWARE',
        };
        const iconConfig = [
          {
            icon: {
              path: this.gapi.maps.SymbolPath.FORWARD_CLOSED_ARROW,
              scale: 3,
              fillOpacity: 1,
            },
            repeat: '50px',
          },
        ];
        const polyline = await this.getGoogleComputeRoute(
          requestBody,
          strokeColor,
          strokeOpacity,
          strokeWeight,
          iconRequired ? iconConfig : null,
        );
        if (polyline) {
          this.drawnPolylines.push(polyline);
        }
      }
    },
    decodePolyline(encoded) {
      let points = [];
      let index = 0,
        lat = 0,
        lng = 0;

      while (index < encoded.length) {
        let b,
          shift = 0,
          result = 0;
        do {
          b = encoded.charCodeAt(index++) - 63;
          result |= (b & 0x1f) << shift;
          shift += 5;
        } while (b >= 0x20);
        let dlat = result & 1 ? ~(result >> 1) : result >> 1;
        lat += dlat;

        shift = 0;
        result = 0;
        do {
          b = encoded.charCodeAt(index++) - 63;
          result |= (b & 0x1f) << shift;
          shift += 5;
        } while (b >= 0x20);
        let dlng = result & 1 ? ~(result >> 1) : result >> 1;
        lng += dlng;

        points.push({ lat: lat / 1e5, lng: lng / 1e5 });
      }
      return points;
    },
    /**
     * A partir de una posición se encarga de extraer la latitud y la longitud
     */
    getLatLng(position) {
      return {
        latitude: typeof position.lat === 'function' ? position.lat() : position.lat,
        longitude: typeof position.lng === 'function' ? position.lng() : position.lng,
      };
    },
    async getGoogleComputeRoute(requestBody, strokeColor, strokeOpacity, strokeWeight, icon) {
      try {
        const url = 'https://routes.googleapis.com/directions/v2:computeRoutes';
        const config = {
          headers: {
            'Content-Type': 'application/json',
            'X-Goog-Api-Key': this.apiKey,
            'X-Goog-FieldMask': 'routes.legs.steps.polyline.encodedPolyline',
          },
        };
        const response = await axios.post(url, requestBody, config);
        const data = response.data;
        if (data.routes && data.routes.length > 0) {
          const route = data.routes[0];
          const path = [];
          route.legs.forEach((leg) => {
            leg.steps.forEach((step) => {
              if (step.polyline && step.polyline.encodedPolyline) {
                path.push(...this.decodePolyline(step.polyline.encodedPolyline));
              }
            });
          });
          return this.buildPolyline(path, strokeColor, strokeOpacity, strokeWeight, icon);
        } else {
          console.log('No se pudo obtener la ruta entre estos puntos.', data);
          return null;
        }
      } catch (error) {
        console.error('Error al consultar la API de Routes:', error);
        return null;
      }
    },
    buildPolyline(path, strokeColor, strokeOpacity, strokeWeight, iconConfig) {
      const polylineOptions = {
        path,
        map: this.map,
        strokeColor: strokeColor,
        strokeOpacity: strokeOpacity,
        strokeWeight: strokeWeight,
      };
      if (iconConfig && iconConfig.length > 0) {
        polylineOptions.icons = iconConfig;
      }
      return new this.gapi.maps.Polyline(polylineOptions);
    },
    /**
     * Metodo que prepara la configuración para la renderización de la direccion
     * @param {*} draggable Si el trazado podra ser editable
     * @param {*} strokeWeight Tamaño de la linea del trazado
     * @param {*} strokeOpacity Opacidad del trazado
     * @param {*} strokeColor Color del trazado
     * @param {*} iconConfig Configuración de los iconos para el trazado
     * @returns
     */
    configDirectionRenderer(draggable, strokeWeight, strokeOpacity, strokeColor, iconConfig) {
      let body = {
        draggable: draggable,
        map: this.map,
        markerOptions: {
          visible: false,
        },
        preserveViewport: true,
        polylineOptions: {
          strokeWeight: strokeWeight,
          strokeOpacity: strokeOpacity,
          strokeColor: strokeColor,
        },
      };
      if (iconConfig != null && iconConfig.length > 0) {
        body = {
          ...body,
          polylineOptions: {
            ...body.polylineOptions,
            icons: iconConfig,
          },
        };
      }
      return body;
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que prepara los trips en el mapa.
     * @param {Array} trips, es el arreglo de trips.
     */
    async setTrips(gapi, zones) {
      //Construyo la zona circular o poligonal dependiendo del array de zonas del spot
      zones.forEach((spotZone) => {
        if (spotZone.zone.length >= 3) {
          this.makePolygon(gapi, spotZone.zone);
        } else if (spotZone.zone.length == 1) {
          this.makeCircle(gapi, spotZone.zone);
        }
      });
      const requireIcon = true;
      await this.markers.forEach(async (marker, index) => {
        this.preparePathInMap(this.markers, marker, index, requireIcon);
      });
    },
    makeCircle(gapi, zone) {
      let radius = zone[0].radio;
      let center = {
        lat: zone[0].lat,
        lng: zone[0].lon,
      };
      new gapi.maps.Circle({
        strokeColor: 'rgba(98, 38, 247, 1)',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: 'rgba(98, 38, 247, 1)',
        fillOpacity: 0.35,
        map: this.map,
        center: center,
        radius: radius,
      });
    },
    makePolygonGeofence(markers, gapi, zone, name) {
      let zonesFormat = [];
      zone.forEach((point) => {
        zonesFormat.push({
          lat: point.lat,
          lng: point.lon,
        });
      });
      const polygonZone = new gapi.maps.Polygon({
        paths: zonesFormat,
        strokeColor: 'rgba(98, 38, 247, 1)',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: 'rgba(98, 38, 247, 1)',
        fillOpacity: 0.35,
        map: this.map,
      });
      this.geoFencePoints.push(polygonZone);

      const colorIcon = '#6226f7';
      const indexMarker = 1;
      const tempObject = this.buildMarker(
        0,
        indexMarker,
        name,
        'geofence',
        zone[0].lat,
        zone[0].lon,
        colorIcon,
        false,
        null,
      );
      markers.push(tempObject);
    },
    makePolygon(gapi, zone) {
      let zonesFormat = [];
      zone.forEach((point) => {
        zonesFormat.push({
          lat: point.lat,
          lng: point.lon,
        });
      });
      const polygonZone = new gapi.maps.Polygon({
        paths: zonesFormat,
        strokeColor: 'rgba(98, 38, 247, 1)',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: 'rgba(98, 38, 247, 1)',
        fillOpacity: 0.35,
        map: this.map,
      });
      this.geoFencePoints.push(polygonZone);
    },

    /**
     * Este metodo utiliza los puntos que recibe en vez de buscarlos a locationIQ
     * @param {Array} trips
     */
    async setMarkers(trips) {
      //Se guardan los trips de manera local.
      this.trips = trips;
      //Por cada viaje, se prepara un marker en mapa.
      if (trips.length === 1) {
        //Caso para cuando no se envia fechas de inicio y termino
        this.markers.push({
          trip: trips[0],
          index: String(0),
          position: trips[0].coordinates.origin,
          zIndex: 0,
          svgMarker: {
            path: this.icon.base,
            fillColor:
              trips[0].departureOrigin && trips[0].departureOrigin.real !== null
                ? this.colorIcon.done
                : this.colorIcon.pending,
            fillOpacity: 1,
            strokeWeight: 0,
            rotation: 0,
            origin: new this.gapi.maps.Point(0, 0),
            anchor: new this.gapi.maps.Point(10.75, 25.75),
            scale: 1.5,
          },
        });
        this.markers.push({
          trip: trips[0],
          index: String(1),
          position: trips[0].coordinates.destination,
          zIndex: 1,
          svgMarker: {
            path: this.icon.trip,
            fillColor:
              trips[0].arrivalDestination && trips[0].arrivalDestination.real !== null
                ? this.colorIcon.done
                : this.colorIcon.pending,
            fillOpacity: 1,
            strokeWeight: 0,
            rotation: 0,
            origin: new this.gapi.maps.Point(0, 0),
            anchor: new this.gapi.maps.Point(10.75, 25.75),
            scale: 1.5,
            labelOrigin: new this.gapi.maps.Point(10.5, 10.5),
          },
          label: {
            text: String(1),
            color: 'white',
            fontSize: '20px',
            fontWeight: 'bold',
          },
        });
      } else {
        trips.forEach((trip, index) => {
          if (index === 0) {
            this.markers.push({
              trip: trip,
              index: String(index),
              position: trip.coordinates.origin,
              zIndex: index,
              svgMarker: {
                path: this.icon.base,
                fillColor: trip.departureOrigin.real !== null ? this.colorIcon.done : this.colorIcon.pending,
                fillOpacity: 1,
                strokeWeight: 0,
                rotation: 0,
                origin: new this.gapi.maps.Point(0, 0),
                anchor: new this.gapi.maps.Point(10.75, 25.75),
                scale: 1.5,
              },
            });
          } else if (index <= trips.length - 1) {
            this.markers.push({
              trip: trip,
              index: String(index),
              position: trip.coordinates.origin,
              zIndex: index,
              svgMarker: {
                path: this.icon.trip,
                fillColor:
                  this.trips[index - 1].arrivalDestination.real !== null ? this.colorIcon.done : this.colorIcon.pending,
                fillOpacity: 1,
                strokeWeight: 0,
                rotation: 0,
                origin: new this.gapi.maps.Point(0, 0),
                anchor: new this.gapi.maps.Point(10.75, 25.5),
                scale: 1.5,
                labelOrigin: new this.gapi.maps.Point(10.5, 10.5),
              },
              label: {
                text: index > 0 ? String(index) : null,
                color: 'white',
                fontSize: '20px',
                fontWeight: 'bold',
              },
            });
            if (index === trips.length - 1) {
              this.markers.push({
                trip: trip,
                index: String(index + 1),
                position: trip.coordinates.destination,
                zIndex: index,
                svgMarker: {
                  path: this.icon.base,
                  fillColor: trip.arrivalDestination.real !== null ? this.colorIcon.done : this.colorIcon.pending,
                  fillOpacity: 1,
                  strokeWeight: 0,
                  rotation: 0,
                  origin: new this.gapi.maps.Point(0, 0),
                  anchor: new this.gapi.maps.Point(10.75, 25.5),
                  scale: 1.5,
                  labelOrigin: new this.gapi.maps.Point(10.5, 10.5),
                },
                label: {
                  text: index !== this.markers.length - 1 ? String(index) : null,
                  color: 'white',
                  fontSize: '20px',
                  fontWeight: 'bold',
                },
              });
            }
          }
        });
      }
    },
    /**
     * Metodo que prepara los listados de marcadores y el listado de puntos para trazar las rutas en el mapa
     * @param {Array} listOfData //Array de ubicaciones proveniente del consumidor
     * @param {Global Array} globalMarkers //Array de alguna variable global pasada
     * @param {Array} pointsRender //Array de puntos para el trazado de la ruta
     * @param {Boolean} isTripMarker //Flag para saber si son trips o bodegas
     * @param {Integer} i //Indice
     * @returns
     */
    createMarkers(listOfData, globalMarkers, pointsRender, markerType, i) {
      let waypList = [];
      listOfData.forEach((activity, index) => {
        if (activity.index === i && activity.spot != null) {
          const indexMarker = markerType == 'Trip' ? activity.subIndex + 1 : 0;
          const name = markerType == 'Trip' ? activity.name : 'Base';
          const street =
            activity.spot.address.street + ', ' + activity.spot.address.city + ', ' + activity.spot.address.state;
          const lat = activity.spot.address.lat;
          const lon = activity.spot.address.lon;
          let realLocation = null;
          //Si la actividad posee datos de lat y lon significa que posee ubicación real de ejecución
          if (activity.lat !== undefined && activity.lat !== 0 && activity.lon !== undefined && activity.lon !== 0) {
            realLocation = {
              lat: activity.lat,
              lon: activity.lon,
            };
          }
          const hasRealLocation = realLocation != null ? true : false;
          //Si el marcador es bodega se pasa nulo debido a que el marcador es una imagen para las bodegas
          let colorIcon = markerType == 'Trip' ? this.markerColor(activity) : null;
          const type = activity.type != undefined ? activity.type : null;

          const initMarker = this.prepareMarker(
            indexMarker,
            lat,
            lon,
            name,
            street,
            hasRealLocation,
            realLocation,
            markerType,
            null,
            type,
          );
          const svgMarker = this.setSvgMarker(initMarker, colorIcon, indexMarker, markerType, 0, null);
          globalMarkers.push(svgMarker);
          const lengthArray = listOfData.length - 1;
          pointsRender = this.preparePointsForDrawing(
            waypList,
            pointsRender,
            markerType,
            lat,
            lon,
            svgMarker,
            lengthArray,
            index,
          );
        }
      });
      return pointsRender;
    },
    markerColor(activity) {
      let colorIcon = null;
      if (activity.state === 'DONE' || activity.state === 'ENDOPERATIONDONE') {
        colorIcon = this.colorIconLastmileV2.done;
      } else if (activity.state === 'REJECTED' || activity.state === 'ENDOPERATIONREJECTED') {
        colorIcon = this.colorIconLastmileV2.rejected;
      } else if (activity.state === 'PARTIALLYDONE' || activity.state === 'ENDOPERATIONPARTIALLYDONE') {
        colorIcon = this.colorIconLastmileV2.partial;
      } else if (activity.state === 'ACTIVE') {
        colorIcon = this.colorIconLastmileV2.active;
      } else if (activity.state === 'UNACTIVE') {
        colorIcon = this.colorIconLastmileV2.unactive;
      } else {
        colorIcon = this.colorIconLastmileV2.pending;
      }
      return colorIcon;
    },
    prepareMarker(
      indexMarker,
      lat,
      lon,
      name,
      street,
      haveRealPosition,
      realLocation,
      markerType,
      lifeParameters,
      type,
    ) {
      let body = {
        position: {
          lat: lat,
          lng: lon,
        },
        soloMarker: true,
        trip: {
          typeName: name,
          typeActivity: type,
          formattedStreet: street ? street : '',
        },
        colorActive: '#5c22eb',
        index: String(indexMarker),
        map: this.map,
      };
      if (lifeParameters) {
        body = {
          ...body,
          lifeSignal: lifeParameters,
        };
      }
      if (haveRealPosition) {
        body = {
          ...body,
          realLocation: {
            lat: realLocation.lat,
            lon: realLocation.lon,
          },
        };
      }
      //ToDo Actualmente el soloMarker esta como true, en un futuro cuando todos los mapas consuman estos metodos se deberan ajustar
      //Dependiendo del soloMarker sera el tipo de contenido que tendra la ventana de información
      let content = '';
      if (markerType == 'Vehicle') {
        content = this.getVehicleInfoWindow(body, body.colorActive);
      } else if (body.soloMarker) {
        content = this.getSpotInfoWindowContentSimple(body, body.colorActive);
      } else if (!body.soloMarker) {
        content = this.getSpotInfoWindowContent(body, indexMarker);
      }
      body = {
        ...body,
        description: content,
      };
      return new this.gapi.maps.Marker(body);
    },
    setSvgMarker(marker, colorIcon, indexMarker, markerType, rotation, state) {
      const mapMarker = require('../assets/bodega.svg');
      if (markerType == 'Trip') {
        marker.setIcon({
          path: indexMarker != 0 ? this.icon.trip : this.icon.base,
          fillColor: colorIcon,
          fillOpacity: 1,
          strokeWeight: 0,
          rotation: rotation ? rotation : 0,
          origin: new this.gapi.maps.Point(0, 0),
          anchor: new this.gapi.maps.Point(10.75, 25.75),
          scale: 1.5,
          labelOrigin: new this.gapi.maps.Point(10.5, 10.5),
        });
        if (indexMarker != 0) {
          marker.setLabel({
            text: String(indexMarker),
            color: 'white',
            fontSize: '20px',
            fontWeight: 'bold',
          });
        }
      } else if (markerType == 'Depot') {
        marker.setIcon({
          url: mapMarker,
          rotation: rotation ? rotation : 0,
          origin: new this.gapi.maps.Point(0, 0),
          anchor: new this.gapi.maps.Point(10.75, 25.75),
          scale: 1.5,
          labelOrigin: new this.gapi.maps.Point(10.5, 10.5),
        });
      } else if (markerType == 'Vehicle') {
        marker.setIcon({
          url: state == 'ACTIVE' ? require('../assets/vehiculomorado.svg') : require('../assets/vehiculogris.svg'),
          origin: new this.gapi.maps.Point(0, 0),
          anchor: new this.gapi.maps.Point(10.75, 25.75),
          scale: 1.2,
          labelOrigin: new this.gapi.maps.Point(0, 0),
        });
      }
      return marker;
    },
    preparePointsForDrawing(waypList, pointsRender, isTripMarker, lat, lon, svgMarker, lengthArray, index) {
      if (isTripMarker == 'Trip') {
        //Mientras aun no tenga 10 registros en el array seguire insertando
        if (waypList.length < 10) {
          const waypoint = {
            location: {
              lat: lat,
              lng: lon,
            },
            stopover: true,
          };
          waypList.push(waypoint);
        }
        //Si el array de waypoints es igual a 10 o si el iterador alcanzo el tamaño del array
        //Se setean todos los waypoints capturados al ultimo punto del array para el trazado de rutas, y se limpia el array
        if (waypList.length == 10 || index == lengthArray) {
          pointsRender[pointsRender.length - 1]['waypoints'] = waypList;
          pointsRender.push(svgMarker);
          waypList = [];
        }
      } else {
        pointsRender.push(svgMarker);
      }
      return pointsRender;
    },
    buildMarker(index, indexMarker, name, street, lat, lon, colorIcon, haveRealPosition, realLocation) {
      const mapMarker = require('../assets/bodega.svg');
      const geoFence = require('../assets/geocerca.svg');
      let body = {
        idRoutePairing: index,
        type: 'other',
        visible: true,
        soloMarker: true,
        colorActive: colorIcon ? colorIcon : '#7A46FB',
        trip: {
          typeName: name,
          formattedStreet: street,
        },
        index: String(indexMarker),
        position: {
          lat: lat,
          lng: lon,
        },
        zIndex: 0,
        svgMarker: {
          url: mapMarker,
          origin: new this.gapi.maps.Point(0, 0),
          anchor: new this.gapi.maps.Point(10.75, 25.75),
          labelOrigin: new this.gapi.maps.Point(10.5, 10.5),
        },
      };
      if (street == 'geofence') {
        body = {
          ...body,
          type: 'geofence',
          trip: {
            typeName: name,
            formattedStreet: '',
          },
          zIndex: 1,
          svgMarker: {
            url: geoFence,
            origin: new this.gapi.maps.Point(0, 0),
            anchor: new this.gapi.maps.Point(10.75, 25.75),
            labelOrigin: new this.gapi.maps.Point(10.5, 10.5),
          },
        };
      } else if (name !== 'Base') {
        body = {
          ...body,
          zIndex: 1,
          svgMarker: {
            path: this.icon.trip,
            fillColor: colorIcon,
            fillOpacity: 1,
            strokeWeight: 0,
            rotation: 0,
            origin: new this.gapi.maps.Point(0, 0),
            anchor: new this.gapi.maps.Point(10.75, 25.75),
            scale: 1.5,
            labelOrigin: new this.gapi.maps.Point(10.5, 10.5),
          },
          label: {
            text: String(indexMarker),
            color: 'white',
            fontSize: '20px',
            fontWeight: 'bold',
          },
        };
      }
      if (haveRealPosition) {
        body = {
          ...body,
          realLocation: {
            lat: realLocation.lat,
            lon: realLocation.lon,
          },
        };
      }
      return body;
    },
    async cleanMarkers() {
      this.markers = [];
      await this.map.setZoom(10);
    },
    async setMultipleMarkersClean(gapi, point) {
      this.markers = [];
      this.setGapi(gapi);
      if (point.type === 'destination') {
        point['formattedStreet'] = point.description;
      }
      if (
        !point.formattedStreet ||
        point.formattedStreet === this.t('routeDetailModal.deliveryForm.locations.notfound')
      ) {
        this.setFormattedStreetByCoord(point);
      }

      this.markers.push({
        trip: point,
        index: String(1),
        position: point.coordinates,
        zIndex: 1,
        soloMarker: true,
        colorActive: '#5c22eb',
        colorInactive: '#686868',
        svgMarker: {
          path: this.icon.base,
          fillColor: '#686868',
          fillOpacity: 1,
          strokeWeight: 0,
          rotation: 0,
          origin: new this.gapi.maps.Point(0, 0),
          anchor: new this.gapi.maps.Point(10.75, 25.75),
          scale: 1.5,
        },
      });

      const centerMap = await this.prepareMapView();
      await this.$refs.mapRef.$mapPromise.then((map) => {
        this.map = map;
      });

      //Edito el centro del mapa
      this.map.setCenter(centerMap);
      await this.map.setZoom(17);
    },
    async setZoomMap(zoom) {
      await this.$refs.mapRef.$mapPromise.then((map) => {
        this.map = map;
        map.setZoom(zoom);
      });
      this.map.setZoom(zoom);
    },
    /**
     * Marca puntos en el mapa basado en una lista de puntos
     * @param {Array} points
     */
    async setMultipleMarkers(gapi, points) {
      this.markers = [];
      if (this.renderer) {
        this.renderer.setMap(null);
      }
      await this.setGapi(gapi);

      console.log('points.length', points.length);
      points.forEach((point, index) => {
        if (point.type === 'destination') {
          point['formattedStreet'] = point.description;
        }

        if (
          !point.formattedStreet ||
          point.formattedStreet === this.t('routeDetailModal.deliveryForm.locations.notfound')
        ) {
          this.setFormattedStreetByCoord(point);
        }
        if ('state' in point) {
          if (point.state == 'PLANNED') {
            this.markers.push({
              trip: point,
              index: String(index),
              position: point.coordinates,
              zIndex: index,
              soloMarker: true,
              colorActive: '#686868',
              colorInactive: '#686868',
              svgMarker: {
                path: this.icon.base,
                fillColor: '#686868',
                fillOpacity: 1,
                strokeWeight: 0,
                rotation: 0,
                origin: new this.gapi.maps.Point(0, 0),
                anchor: new this.gapi.maps.Point(10.75, 25.75),
                scale: 1.5,
              },
            });
          } else {
            var colorState = '';
            if (point.state == 'DONE') {
              colorState = '#52A145';
            } else if (point.state == 'REJECTED' || point.state == 'CANCELED') {
              colorState = '#e62121';
            } else if (point.state == 'NOTDONE') {
              colorState = '#03475E';
            } else if (point.state == 'PARTIALLYDONE') {
              colorState = '#eeb71f';
            }
            this.markers.push({
              trip: point,
              index: String(index),
              position: point.coordinates,
              zIndex: index,
              soloMarker: true,
              colorActive: colorState,
              colorInactive: colorState,
              svgMarker: {
                path: this.icon.base,
                fillColor: colorState,
                fillOpacity: 1,
                strokeWeight: 0,
                rotation: 0,
                origin: new this.gapi.maps.Point(0, 0),
                anchor: new this.gapi.maps.Point(10.75, 25.75),
                scale: 1.5,
              },
            });
          }
        } else {
          this.markers.push({
            trip: point,
            index: String(index),
            position: point.coordinates,
            zIndex: index,
            soloMarker: true,
            colorActive: '#5c22eb',
            colorInactive: '#686868',
            svgMarker: {
              path: this.icon.base,
              fillColor: '#686868',
              fillOpacity: 1,
              strokeWeight: 0,
              rotation: 0,
              origin: new this.gapi.maps.Point(0, 0),
              anchor: new this.gapi.maps.Point(10.75, 25.75),
              scale: 1.5,
            },
          });
        }
      });

      const centerMap = await this.prepareMapView();
      await this.$refs.mapRef.$mapPromise.then((map) => {
        this.map = map;
      });

      //Edito el centro del mapa
      this.map.setCenter(centerMap);

      //Se aplica un zoom lo suficientemente amplio en el cual se muestren todos los marcadores
      let bounds = new gapi.maps.LatLngBounds();

      console.log('this.markers', this.markers.length);
      if (this.markers.length === 1) {
        const marker = this.markers[0];
        const loc = new gapi.maps.LatLng(marker.position.lat, marker.position.lng);

        await this.$refs.mapRef.$mapPromise.then((map) => {
          map.setCenter(loc);
          map.setZoom(16); // 👈 el zoom
          this.map = map;
        });
      } else {
        this.markers.forEach((marker) => {
          const loc = new gapi.maps.LatLng(marker.position.lat, marker.position.lng);
          bounds.extend(loc);
        });
        await this.$refs.mapRef.$mapPromise.then((map) => {
          map.fitBounds(bounds);
          this.map = map;
        });
      }
      this.$mapPromise = Promise.resolve(this.map);
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que prepara la ventana de informacion de un path.
     * @param {Path} path, la informacion de una ruta.
     */
    getPathInfoWindow(path) {
      //En caso de que este abierta la ventana, se cierra.
      this.infoWinOpen = false;

      //Se define la posicion de la ventana.
      this.infoOptions.pixelOffset = new this.gapi.maps.Size(0, 0);

      //Se obtiene el contenido para la ventana de informacion.
      this.infoContent = this.getPathInfoWindowContent(path.id);

      //Se obtiene un especifico path de la lista.
      const tempPath = path.draw;

      //Se obtiene la posicion media de su dibujado.
      const middleIndexPath = Math.round((tempPath.length + 1) / 2);

      //Se ajusta la ubicacion de la ventana de informacion.
      this.infoWindowPos = {
        lat: tempPath[middleIndexPath].lat,
        lng: tempPath[middleIndexPath].lng,
      };

      //Se muestra en pantalla.
      this.infoWinOpen = true;
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que retorna la estructura html de un path.
     * @param {Integer} index, es la posicion una ruta dentro de la lista "paths".
     * @returns {String} structura html de la ventana de info.
     */
    getPathInfoWindowContent: function (index) {
      //NOTA: El index de un path tambien se puede considerar como el index del spot inicial.

      //Titulo de la ventana de informacion.
      const titlePath = this.t('routeDetailModal.routeDetailModal.journey.title');
      //Index para el dibujado en la ventana.
      const indexInit = parseInt(index) === 0 ? '' : parseInt(index); //Si index===0, pertenece a la base.

      var indexFinish;

      if (this.trips.length === 1) {
        indexFinish = 1;
      } else {
        //Si el index es el ultimo punto, pertenece a la base.
        indexFinish = parseInt(index) + 1 === this.trips.length ? '' : parseInt(index) + 1;
      }

      //Se parsea los segundos de duracion a tiempo de duracion.
      const drivingDuration = new Date(this.trips[index].arrivalDestination.drivingTime * 1000)
        .toISOString()
        .substr(11, 8);
      const durationSplitted = drivingDuration.split(':');
      const drivingTime = durationSplitted[0] + ':' + durationSplitted[1] + ':' + durationSplitted[2];

      //Despliegue de estructura.
      return `
              <div class="card" style="height: 60px; width: 190px; border: 0">
                <div class="card-content">
                  <span style="fill: #0096ca;">
                    <span style="font-size: 110%;font-weight: bold;">
                      ${titlePath}
                    </span>
                    <div style="position: relative; text-align: center;">
                      <div style="font-weight:500; margin-top: 5px; color: #03475e; position: absolute; left: 0%;">
                        <svg xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 0 36 32" width="30px">
                          <path d="M0 0h24v24H0z" fill="none" />
                          <path
                            d="M10.5,26 C17.5,19.3170648 21,14.0809537 21,10.2916667 C21,4.60773612 16.2989899,0 10.5,0 C4.70101013,0 0,4.60773612 0,10.2916667 C0,14.0809537 3.5,19.3170648 10.5,26 Z"
                          />
                        </svg>
                      </div>
                    </div>
                    <div style="position: relative; text-align: center;">
                      <div style="font-weight:500; margin-top: 0px; color: #03475e; position: absolute; transform: translate(31%, 5%);">
                        <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 0 28 32" width="40px">
                          <path d="M0 0h24v24H0z" fill="none"/>
                          <path d="M22 12l-4-4v3H3v2h15v3z"/>
                        </svg>
                      </div>
                    </div>
                    <div style="position: relative;">
                      <div style="font-weight:500; margin-top: 5px; color: #03475e; position: absolute; left: 23%;">
                        <svg xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 0 36 32" width="30px">
                          <path d="M0 0h24v24H0z" fill="none" />
                          <path
                            d="M10.5,26 C17.5,19.3170648 21,14.0809537 21,10.2916667 C21,4.60773612 16.2989899,0 10.5,0 C4.70101013,0 0,4.60773612 0,10.2916667 C0,14.0809537 3.5,19.3170648 10.5,26 Z"
                          />
                        </svg>
                      </div>
                      <span style="
                        margin-top: 13px;
                        position: absolute;
                        transform: translate(45%, -35%);
                        font-weight: normal;
                        color: white;
                        font-weight: bold;
                        font-size: 120%;
                        display: inline-block;
                        z-index: 2;"
                      >
                        ${indexInit}
                      </span>
                      <span style="
                        margin-top: 13px;
                        position: absolute;
                        transform: translate(530%, -35%);
                        font-weight: normal;
                        color: white;
                        font-weight: bold;
                        font-size: 120%;
                        display: inline-block;
                        z-index: 2;"
                      >
                        ${indexFinish}
                      </span>
                      <div style="color: black; position: absolute; font-size: 110%; margin-top: 8px; right: 0%;">                               
                        ${drivingTime}
                      </div>
                    </div>
                  </span>
                </div>
              </div>`;
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que parsea la fecha en segundos.
     * @param {String} date es la fecha a parsear.
     * @returns la fecha en segundos.
     */
    dateToInteger(date) {
      const dateTemp = new Date(date);
      return dateTemp.getTime();
    },
    /**
     * Metodo que colorea un marcador en el mapa
     */
    paintMarker(marker) {
      // Para luego poder quitarle el color
      this.selectedSoloMarker = marker;

      // Se pinta solo el seleccionado y los demas se retornan al color inactivo
      this.markers.forEach((m) => {
        m.svgMarker.fillColor = m.index === marker.index ? m.colorActive : m.colorInactive;
      });

      // Refrescar la lista de marcadores
      if (this.markers.length === 1) {
        // Coloca un punto por delante en el caso de ser solo 1 punto
        const aux = Object.assign({}, this.markers[0]);
        this.markers.splice(0, 0, aux);
      } else {
        this.updateMarkersList();
      }
    },
    /**
     * Metodo que permite gestionar el cierre de la ventana de info
     */
    closeMarkerInfo() {
      //En el caso de los marcadores independientes, se les quita el color
      if (this.selectedSoloMarker) {
        this.selectedSoloMarker.svgMarker.fillColor = this.selectedSoloMarker.colorInactive;

        //Refresca la lista de marcadores
        if (this.markers.length === 2) {
          //Caso en el que era solo 1 punto (ver donde paintMarker), se elimina el duplicado
          if (this.markers[0].index === this.markers[1].index) {
            this.markers.splice(0, 1);
          }
        }
        this.updateMarkersList();

        this.selectedSoloMarker = null;
      }
    },
    /**
     * Metodo que permite actualizar la lista de marcadores moviendo el ultimo elemento de la lista al primero
     */
    updateMarkersList() {
      const aux = this.markers.splice(0, 1);
      this.markers.push(aux[0]);
    },
    /**
     * Metodo que obtiene y setea la direccion usando latitud y longitud de un marcador
     * @param {*} coords latitud y longitud del punto
     */
    setFormattedStreetByCoord(marker) {
      const geocoder = new this.gapi.maps.Geocoder();

      geocoder
        .geocode({ location: marker.coordinates })
        .then((response) => {
          if (response) {
            marker['formattedStreet'] = response.results[0].formatted_address;
            return;
          }
          console.log('Geocoder response not found');
          marker['formattedStreet'] = this.t('routeDetailModal.deliveryForm.locations.notfound');
        })
        .catch((e) => {
          console.log('Geocoder error');
          console.log(e);
          marker['formattedStreet'] = this.t('routeDetailModal.deliveryForm.locations.notfound');
        });
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que prepara la ventana de informacion de un trip.
     * @param {Trip} marker, es el punto del trip dentro del mapa.
     * @param {Integer} index, es la posicion del punto del trip.
     */
    getSpotInfoWindow(marker, index) {
      //En caso de que este abierta la ventana, se cierra.
      this.infoWinOpen = false;

      console.log('Evento ', marker);
      //Se define la posicion de la ventana.
      this.infoOptions.pixelOffset = {
        width: 0,
        height: -35,
      };
      this.setMarkerRealLocation(marker);
      if (marker.type == 'event') {
        this.infoContent = marker.soloMarker
          ? this.getEventInfoWindowContentSimple(marker, marker.colorActive)
          : this.getEventInfoWindowContentSimple(marker, index);
      } else {
        //Se obtiene el contenido para la ventana de informacion.
        this.infoContent = marker.soloMarker
          ? this.getSpotInfoWindowContentSimple(marker, marker.colorActive)
          : this.getSpotInfoWindowContent(marker, index);
        //Se colorea el marcador seleccionado solo si es de una lista de marcadores independientes (no hay origen ni destino)
        if (marker.soloMarker && this.markers.length > 0) {
          this.paintMarker(marker);
        }
      }

      //Se ajusta la ubicacion de la ventana de informacion.
      this.infoWindowPos = marker.position;
      //Se muestra en pantalla.
      this.infoWinOpen = true;
    },
    async setMarkerRealLocationGoogle(globalArray, marker) {
      if (globalArray.length > 0) {
        const lastPosition = globalArray.length - 1;
        //Si el marcador seleccionado no es de ubicación real y ya hay algun marcador de ubicación real en el mapa, entonces se elimina
        if (
          !marker.trip.typeName.includes('Ubicación de ejecución') &&
          globalArray[lastPosition].trip.typeName.includes('Ubicación de ejecución')
        ) {
          const deletedMarker = globalArray.pop();
          deletedMarker.setMap(null);
          this.oms.removeMarker(deletedMarker);
        }
        //Valida que la ubicación real tenga datos validos, si existen los datos entonces redibuja los marcadores en el mapa
        if (
          marker.type !== 'Base' &&
          marker.realLocation &&
          marker.realLocation.lat !== undefined &&
          marker.realLocation.lat !== 0 &&
          marker.realLocation.lon !== undefined &&
          marker.realLocation.lon !== 0
        ) {
          const initMarker = this.prepareMarker(
            marker.index + globalArray.length,
            marker.realLocation.lat,
            marker.realLocation.lon,
            `${marker.trip.typeName} Ubicación de ejecución`,
            marker.trip.formattedStreet,
            false,
            null,
            'Trip',
            null,
            null,
          );
          const markerRealPosition = this.setSvgMarker(
            initMarker,
            this.colorIconLastmileV2.realLocation,
            marker.index,
            'Trip',
            0,
            null,
          );
          markerRealPosition.setMap(this.map);
          this.oms.addMarker(markerRealPosition);
          globalArray.push(markerRealPosition);

          let bounds = new this.gapi.maps.LatLngBounds();
          globalArray.forEach((marker) => {
            bounds.extend(new this.gapi.maps.LatLng(marker.position.lat(), marker.position.lng()));
          });
          await this.$refs.mapRef.$mapPromise.then((map) => {
            map.fitBounds(bounds);
          });
        }
      }
    },
    async setMarkerRealLocation(marker) {
      if (this.markersLastmileLite.length > 0) {
        const lastPosition = this.markersLastmileLite.length - 1;
        //Si el marcador seleccionado no es de ubicación real y ya hay algun marcador de ubicación real en el mapa, entonces se elimina
        if (
          !marker.trip.typeName.includes('Ubicación de ejecución') &&
          this.markersLastmileLite[lastPosition].trip.typeName.includes('Ubicación de ejecución')
        )
          this.markersLastmileLite.pop();
        //Valida que la ubicación real tenga datos validos, si existen los datos entonces redibuja los marcadores en el mapa
        if (
          marker.type !== 'Base' &&
          marker.realLocation &&
          marker.realLocation.lat !== undefined &&
          marker.realLocation.lat !== 0 &&
          marker.realLocation.lon !== undefined &&
          marker.realLocation.lon !== 0
        ) {
          this.markersLastmileLite.push(
            this.buildMarker(
              marker.idRoutePairing,
              marker.index,
              `${marker.trip.typeName} Ubicación de ejecución`,
              marker.trip.formattedStreet,
              marker.realLocation.lat,
              marker.realLocation.lon,
              this.colorIconLastmileV2.realLocation,
              false,
              null,
            ),
          );
          let bounds = new this.gapi.maps.LatLngBounds();
          this.markersLastmileLite.forEach((marker) => {
            bounds.extend(new this.gapi.maps.LatLng(marker.position.lat, marker.position.lng));
          });
          await this.$refs.mapRef.$mapPromise.then((map) => {
            map.fitBounds(bounds);
          });
        }
      }
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que retorna la estructura html de un trip.
     * @param {Trip} marker, es el punto del trip dentro del mapa.
     * @param {Integer} index, es la posicion del punto del trip.
     * @returns {String} structura html de la ventana de info.
     */
    getSpotInfoWindowContent: function (marker, index) {
      const schedArrival =
        this.t('routeDetailModal.routeDetailModal.endTrip') +
        ' ' +
        this.t('routeDetailModal.routeDetailModal.schedTimeReduced');
      const schedArrivalTime = this.t('routeDetailModal.routeDetailModal.time', {
        time:
          index !== 0 && this.trips[index - 1] && this.trips[index - 1].arrivalDestination
            ? this.trips[index - 1].arrivalDestination.sched
            : '--:--',
      });
      const schedArrivalText = `
      <div style="font-weight:500; margin-top: 8px; color: #03475e; fill: #03475e; position: absolute; left: -0.5%;">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          enable-background="new 0 0 24 24"
          height="18px"
          viewBox="0 0 24 24"
          width="18px"
        >
          <g><rect fill="none" height="24" width="24" /></g>
          <g>
            <g>
              <rect height="2" width="6" x="9" y="1" />
              <path
                d="M19.03,7.39l1.42-1.42c-0.43-0.51-0.9-0.99-1.41-1.41l-1.42,1.42C16.07,4.74,14.12,4,12,4c-4.97,0-9,4.03-9,9 c0,4.97,4.02,9,9,9s9-4.03,9-9C21,10.88,20.26,8.93,19.03,7.39z M13,14h-2V8h2V14z"
              />
            </g>
          </g>
        </svg>
        ${schedArrival}:
      </div>
      <div style="font-weight:500; margin-top: 8px; color: #03475e; fill: #03475e; position: absolute; right: 0%;">                               
        ${schedArrivalTime}
      </div>
      `;

      const arrivalTimeTemp =
        index !== 0 && this.trips[index - 1] && this.trips[index - 1].arrivalDestination
          ? this.trips[index - 1].arrivalDestination.real
          : '--:--';
      const realArrival =
        this.t('routeDetailModal.routeDetailModal.endTrip') +
        ' ' +
        this.t('routeDetailModal.routeDetailModal.realTime');
      const realArrivalTime = this.t('routeDetailModal.routeDetailModal.time', {
        time: arrivalTimeTemp !== null ? arrivalTimeTemp : '--:--',
      });
      const realArrivalText = `
      <div style="font-weight:500; margin-top: 32px; color: #e69c21; fill: #e69c21; position: absolute; left: -0.5%;">
        <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px">
          <path d="M0 0h24v24H0z" fill="none" />
          <path
            d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
          />
          <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
        </svg>
        ${realArrival}:
      </div>
      <div style="font-weight:500; margin-top: 32px; color: #e69c21; fill: #e69c21; position: absolute; right: 0%;">                               
        ${realArrivalTime}
      </div>
      `;
      const schedDeparture =
        this.t('routeDetailModal.routeDetailModal.startTrip') +
        ' ' +
        this.t('routeDetailModal.routeDetailModal.schedTimeReduced');
      const schedDepartureTime = this.t('routeDetailModal.routeDetailModal.time', {
        time: marker.trip.departureOrigin ? marker.trip.departureOrigin.sched : '--:--',
      });
      const schedDepartureText = `
      <div style="font-weight:500; margin-top: 8px; color: #03475e; fill: #03475e; position: absolute; left: -0.5%;">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          enable-background="new 0 0 24 24"
          height="18px"
          viewBox="0 0 24 24"
          width="18px"
        >
          <g><rect fill="none" height="24" width="24" /></g>
          <g>
            <g>
              <rect height="2" width="6" x="9" y="1" />
              <path
                d="M19.03,7.39l1.42-1.42c-0.43-0.51-0.9-0.99-1.41-1.41l-1.42,1.42C16.07,4.74,14.12,4,12,4c-4.97,0-9,4.03-9,9 c0,4.97,4.02,9,9,9s9-4.03,9-9C21,10.88,20.26,8.93,19.03,7.39z M13,14h-2V8h2V14z"
              />
            </g>
          </g>
        </svg>
        ${schedDeparture}:
      </div>
      <div style="font-weight:500; margin-top: 8px; color: #03475e; fill: #03475e; position: absolute; right: 0%;">                               
        ${schedDepartureTime}
      </div>
      `;
      const spotTitle = marker.index != this.markers.length - 1 ? marker.trip.origin : marker.trip.destination;
      const spotAddress =
        marker.index != this.markers.length - 1
          ? marker.trip.originAddress.street
          : marker.trip.destinationAddress.street;

      const realDeparture =
        this.t('routeDetailModal.routeDetailModal.startTrip') +
        ' ' +
        this.t('routeDetailModal.routeDetailModal.realTime');
      const realDepartureTime = this.t('routeDetailModal.routeDetailModal.time', {
        time:
          marker.trip.departureOrigin && marker.trip.departureOrigin.real !== null
            ? marker.trip.departureOrigin.real
            : '--:--',
      });
      const realDepartureText = `
      <div style="font-weight:500; margin-top: 32px; color: #e69c21; fill: #e69c21; position: absolute; left: -0.5%;">
        <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px">
          <path d="M0 0h24v24H0z" fill="none" />
          <path
            d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
          />
          <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
        </svg>
        ${realDeparture}:
      </div>
      <div style="font-weight:500; margin-top: 32px; color: #e69c21; fill: #e69c21; position: absolute; right: 0%;">                               
        ${realDepartureTime}
      </div>
      `;
      if (marker.trip.departureOrigin) {
        return `
        <div class="card" style="height:120px; width:180px; minWidth:250px;border:0;">
                <div class="card-content">
                  <span style="fill: #0096ca;">
                    <svg xmlns="http://www.w3.org/2000/svg" height="25px" viewBox="0 0 36 32" width="25px">
                      <path d="M0 0h24v24H0z" fill="none" />
                      <path
                        d="M10.5,26 C17.5,19.3170648 21,14.0809537 21,10.2916667 C21,4.60773612 16.2989899,0 10.5,0 C4.70101013,0 0,4.60773612 0,10.2916667 C0,14.0809537 3.5,19.3170648 10.5,26 Z"
                      />
                    </svg>
                    <span style="font-size: 110%;font-weight: bold;">
                      ${spotTitle}
                    </span>
                  </span>
                  <div class="content" style="color:#6c757d;">
                    <span style="color: #686868;font-weight:500">
                      ${spotAddress}
                    </span>
                    <div style="position: relative; text-align: center;">
                      ${index !== 0 ? schedArrivalText : schedDepartureText}
                    </div>
                    <div style="position: relative; text-align: center;">
                      ${index !== 0 ? realArrivalText : realDepartureText}
                    </div>
                  </div>
                </div>
            </div>
        </div>`;
      } else {
        return `
        <div class="card" style="height:auto; width:180px; minWidth:250px;border:0;">
                <div class="card-content">
                  <span style="fill: #0096ca;">
                    <svg xmlns="http://www.w3.org/2000/svg" height="25px" viewBox="0 0 36 32" width="25px">
                      <path d="M0 0h24v24H0z" fill="none" />
                      <path
                        d="M10.5,26 C17.5,19.3170648 21,14.0809537 21,10.2916667 C21,4.60773612 16.2989899,0 10.5,0 C4.70101013,0 0,4.60773612 0,10.2916667 C0,14.0809537 3.5,19.3170648 10.5,26 Z"
                      />
                    </svg>
                    <span style="font-size: 110%;font-weight: bold;">
                      ${spotTitle}
                    </span>
                  </span>
                  <div class="content" style="color:#6c757d;">
                    <span style="color: #686868;font-weight:500">
                      ${spotAddress}
                    </span>
                  </div>
                </div>
            </div>
        </div>`;
      }
    },

    getEventInfoWindowContentSimple: function (marker, color) {
      const eventTitle = marker.title;
      const eventDate = marker.eventDate;
      return `<div class="card" style="height:auto; width:95%; minWidth:250px;border:0;">
                      <div class="card-content">
                        <span style="fill: ${color};">
                          <svg xmlns="http://www.w3.org/2000/svg" height="25px" viewBox="0 0 36 32" width="25px">
                            <path d="M0 0h24v24H0z" fill="none" />
                            <path
                              d="M10.5,26 C17.5,19.3170648 21,14.0809537 21,10.2916667 C21,4.60773612 16.2989899,0 10.5,0 C4.70101013,0 0,4.60773612 0,10.2916667 C0,14.0809537 3.5,19.3170648 10.5,26 Z"
                            />
                          </svg>
                          <span style="font-size: 110%;font-weight: bold;">
                            ${eventTitle}
                          </span>
                        </span>
                        <div class="content" style="color:#6c757d;">
                        <span style="color: #686868;font-weight:500">
                          ${moment(eventDate).format('DD/MM/YY HH:mm:ss')}
                        </span>
                      </div>
                      </div>
                  </div>
              </div>`;
    },
    getVehicleInfoWindow: function (marker, color) {
      //para este caso el typeName es la patente del vehículo
      const spotTitle = marker.trip.typeName;

      return `<div class="card" style="height:auto; width:100%; margin-top: 5px; border:0;">
                <div class="card-content">
                  <div style="fill: ${color}; min-width: 150px;" >
                    <span style="font-size: 130%;font-weight: bold;">
                      Indicadores del dispositivo
                    </span>
                  </div>
                  <div style="display: flex; margin-top: 10px">
                    <div style="display: flex; justify-content:center; align-items:center;">
                      <svg width="25" height="25" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <mask id="mask0_110_3956" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
                        <rect x="0.0146484" width="17.8328" height="17.8328" fill="#D9D9D9"/>
                        </mask>
                        <g mask="url(#mask0_110_3956)">
                        <path d="M4.47324 14.1175V14.8606C4.47324 15.0711 4.40203 15.2476 4.25961 15.39C4.1172 15.5324 3.94073 15.6036 3.7302 15.6036H2.98717C2.77665 15.6036 2.60018 15.5324 2.45776 15.39C2.31535 15.2476 2.24414 15.0711 2.24414 14.8606V8.91631L3.80451 4.45812C3.87881 4.23521 4.01194 4.05564 4.20389 3.91942C4.39584 3.7832 4.60946 3.71509 4.84475 3.71509H13.0181C13.2534 3.71509 13.467 3.7832 13.659 3.91942C13.8509 4.05564 13.984 4.23521 14.0583 4.45812L15.6187 8.91631V14.8606C15.6187 15.0711 15.5475 15.2476 15.4051 15.39C15.2627 15.5324 15.0862 15.6036 14.8757 15.6036H14.1326C13.9221 15.6036 13.7457 15.5324 13.6032 15.39C13.4608 15.2476 13.3896 15.0711 13.3896 14.8606V14.1175H4.47324ZM4.32463 7.43025H13.5382L12.758 5.20115H5.10481L4.32463 7.43025ZM5.58778 11.8884C5.89738 11.8884 6.16054 11.7801 6.37725 11.5634C6.59397 11.3466 6.70233 11.0835 6.70233 10.7739C6.70233 10.4643 6.59397 10.2011 6.37725 9.98442C6.16054 9.7677 5.89738 9.65934 5.58778 9.65934C5.27819 9.65934 5.01503 9.7677 4.79831 9.98442C4.58159 10.2011 4.47324 10.4643 4.47324 10.7739C4.47324 11.0835 4.58159 11.3466 4.79831 11.5634C5.01503 11.7801 5.27819 11.8884 5.58778 11.8884ZM12.2751 11.8884C12.5847 11.8884 12.8478 11.7801 13.0645 11.5634C13.2813 11.3466 13.3896 11.0835 13.3896 10.7739C13.3896 10.4643 13.2813 10.2011 13.0645 9.98442C12.8478 9.7677 12.5847 9.65934 12.2751 9.65934C11.9655 9.65934 11.7023 9.7677 11.4856 9.98442C11.2689 10.2011 11.1605 10.4643 11.1605 10.7739C11.1605 11.0835 11.2689 11.3466 11.4856 11.5634C11.7023 11.7801 11.9655 11.8884 12.2751 11.8884ZM3.7302 12.6315H14.1326V8.91631H3.7302V12.6315Z" fill="#6825F3"/>
                </g>
              </svg>
              <span style="font-size: 120%;justify-content:center; align-items:center; margin-left: 5px">
                ${spotTitle}
              </span>
            </div>
            <div style="display: flex; justify-content:center; align-items:center; margin-left: 10px">
              ${this.getBattery(marker)}
            </div>
            <div style="display: flex; justify-content:center; align-items:center; margin-left: 10px">
              ${this.getSignal(marker)}
            </div>
          </div>
          
          <div style="display: flex; margin-top: 10px">
            <div style="display: flex; justify-content:center; align-items:center;">
              ${this.getAppVersion(marker)}
            </div>
          </div>
        </div>
      </div>`;
    },
    getAppVersion(marker) {
      if (marker.lifeSignal) {
        return `
          <span style="font-size: 120%;justify-content:center; align-items:center">
            Versión ${marker.lifeSignal.appVersion}
          </span>`;
      } else {
        return `
        <span style="font-size: 120%;justify-content:center; align-items:center">
          Versión 1.0.0
        </span>`;
      }
    },
    getBattery(marker) {
      if (marker.lifeSignal) {
        return `
              <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="mask0_110_3951" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="17" height="17">
                <rect width="16.8035" height="16.8035" fill="#D9D9D9"/>
                </mask>
                <g mask="url(#mask0_110_3951)">
                <path d="M5.60151 15.403C5.40314 15.403 5.23685 15.3359 5.10266 15.2017C4.96846 15.0675 4.90137 14.9013 4.90137 14.7029V3.50058C4.90137 3.30221 4.96846 3.13592 5.10266 3.00173C5.23685 2.86753 5.40314 2.80044 5.60151 2.80044H7.0018V1.40015H9.80238V2.80044H11.2027C11.401 2.80044 11.5673 2.86753 11.7015 3.00173C11.8357 3.13592 11.9028 3.30221 11.9028 3.50058V14.7029C11.9028 14.9013 11.8357 15.0675 11.7015 15.2017C11.5673 15.3359 11.401 15.403 11.2027 15.403H5.60151ZM6.30166 12.6025H10.5025V4.20072H6.30166V12.6025Z" fill="#6825F3"/>
                </g>
              </svg>
              <span style="font-size: 120%;justify-content:center; align-items:center;">
                ${marker.lifeSignal.battery}%
              </span>
        `;
      } else {
        return `
        <span style="font-size: 120%;justify-content:center; align-items:center; margin-left: 5px">
          0%
        </span>
        `;
      }
    },
    getSignal(marker) {
      if (marker.lifeSignal) {
        let signalText = '';
        if (marker.lifeSignal.signal > -60) {
          signalText = `
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.15375 15C0.83325 15 0.560833 14.8878 0.3365 14.6635C0.112167 14.4392 0 14.1667 0 13.8462V11.1538C0 10.8333 0.112167 10.5608 0.3365 10.3365C0.560833 10.1122 0.83325 10 1.15375 10C1.47425 10 1.74675 10.1122 1.97125 10.3365C2.19558 10.5608 2.30775 10.8333 2.30775 11.1538V13.8462C2.30775 14.1667 2.19558 14.4392 1.97125 14.6635C1.74675 14.8878 1.47425 15 1.15375 15Z" fill="#6825F3"/>
            <path d="M13.154 15C12.8335 15 12.561 14.8878 12.3365 14.6635C12.1122 14.4392 12 14.1667 12 13.8462V1.15375C12 0.833251 12.1122 0.560834 12.3365 0.336501C12.561 0.112167 12.8335 0 13.154 0C13.4745 0 13.7469 0.112167 13.9712 0.336501C14.1956 0.560834 14.3078 0.833251 14.3078 1.15375V13.8462C14.3078 14.1667 14.1956 14.4392 13.9712 14.6635C13.7469 14.8878 13.4745 15 13.154 15Z" fill="#6825F3"/>
            <path d="M7.15375 15C6.83325 15 6.56083 14.8878 6.3365 14.6635C6.11217 14.4392 6 14.1668 6 13.8463V6.15375C6 5.83325 6.11217 5.56083 6.3365 5.3365C6.56083 5.11217 6.83325 5 7.15375 5C7.47425 5 7.74667 5.11217 7.971 5.3365C8.19533 5.56083 8.3075 5.83325 8.3075 6.15375V13.8463C8.3075 14.1668 8.19533 14.4392 7.971 14.6635C7.74667 14.8878 7.47425 15 7.15375 15Z" fill="#6825F3"/>
          </svg>
          <span style="font-size: 120%;justify-content:center; align-items:center; margin-left: 5px">
            Alta
          </span>
          `;
        } else if (marker.lifeSignal.signal <= -60 && marker.lifeSignal.signal >= -89) {
          signalText = `
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.15375 15C0.83325 15 0.560834 14.8878 0.3365 14.6635C0.112167 14.4392 0 14.1667 0 13.8462V11.1538C0 10.8333 0.112167 10.5608 0.3365 10.3365C0.560834 10.1122 0.83325 10 1.15375 10C1.47425 10 1.74675 10.1122 1.97125 10.3365C2.19558 10.5608 2.30775 10.8333 2.30775 11.1538V13.8462C2.30775 14.1667 2.19558 14.4392 1.97125 14.6635C1.74675 14.8878 1.47425 15 1.15375 15Z" fill="#6825F3"/>
            <path d="M13.154 15C12.8335 15 12.561 14.8878 12.3365 14.6635C12.1122 14.4392 12 14.1667 12 13.8462V1.15375C12 0.833251 12.1122 0.560834 12.3365 0.336501C12.561 0.112167 12.8335 0 13.154 0C13.4745 0 13.7469 0.112167 13.9712 0.336501C14.1956 0.560834 14.3078 0.833251 14.3078 1.15375V13.8462C14.3078 14.1667 14.1956 14.4392 13.9712 14.6635C13.7469 14.8878 13.4745 15 13.154 15Z" fill="#E7E1F5"/>
            <path d="M7.15375 15C6.83325 15 6.56083 14.8878 6.3365 14.6635C6.11217 14.4392 6 14.1668 6 13.8463V6.15375C6 5.83325 6.11217 5.56083 6.3365 5.3365C6.56083 5.11217 6.83325 5 7.15375 5C7.47425 5 7.74667 5.11217 7.971 5.3365C8.19533 5.56083 8.3075 5.83325 8.3075 6.15375V13.8463C8.3075 14.1668 8.19533 14.4392 7.971 14.6635C7.74667 14.8878 7.47425 15 7.15375 15Z" fill="#6825F3"/>
          </svg>
          <span style="font-size: 120%;justify-content:center; align-items:center; margin-left: 5px">
            Media
          </span>
          `;
        } else if (marker.lifeSignal.signal <= -90 && marker.lifeSignal.signal >= -200) {
          signalText = `
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.15375 15C0.83325 15 0.560834 14.8878 0.3365 14.6635C0.112167 14.4392 0 14.1667 0 13.8462V11.1538C0 10.8333 0.112167 10.5608 0.3365 10.3365C0.560834 10.1122 0.83325 10 1.15375 10C1.47425 10 1.74675 10.1122 1.97125 10.3365C2.19558 10.5608 2.30775 10.8333 2.30775 11.1538V13.8462C2.30775 14.1667 2.19558 14.4392 1.97125 14.6635C1.74675 14.8878 1.47425 15 1.15375 15Z" fill="#6825F3"/>
            <path d="M13.154 15C12.8335 15 12.561 14.8878 12.3365 14.6635C12.1122 14.4392 12 14.1667 12 13.8462V1.15375C12 0.833251 12.1122 0.560834 12.3365 0.336501C12.561 0.112167 12.8335 0 13.154 0C13.4745 0 13.7469 0.112167 13.9712 0.336501C14.1956 0.560834 14.3078 0.833251 14.3078 1.15375V13.8462C14.3078 14.1667 14.1956 14.4392 13.9712 14.6635C13.7469 14.8878 13.4745 15 13.154 15Z" fill="#E7E1F5"/>
            <path d="M7.15375 15C6.83325 15 6.56083 14.8878 6.3365 14.6635C6.11217 14.4392 6 14.1668 6 13.8463V6.15375C6 5.83325 6.11217 5.56083 6.3365 5.3365C6.56083 5.11217 6.83325 5 7.15375 5C7.47425 5 7.74667 5.11217 7.971 5.3365C8.19533 5.56083 8.3075 5.83325 8.3075 6.15375V13.8463C8.3075 14.1668 8.19533 14.4392 7.971 14.6635C7.74667 14.8878 7.47425 15 7.15375 15Z" fill="#6825F3"/>
          </svg>
          <span style="font-size: 120%;justify-content:center; align-items:center; margin-left: 5px">
            Baja
          </span>
          `;
        } else {
          signalText = `
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.15375 15C0.83325 15 0.560834 14.8878 0.3365 14.6635C0.112167 14.4392 0 14.1667 0 13.8462V11.1538C0 10.8333 0.112167 10.5608 0.3365 10.3365C0.560834 10.1122 0.83325 10 1.15375 10C1.47425 10 1.74675 10.1122 1.97125 10.3365C2.19558 10.5608 2.30775 10.8333 2.30775 11.1538V13.8462C2.30775 14.1667 2.19558 14.4392 1.97125 14.6635C1.74675 14.8878 1.47425 15 1.15375 15Z" fill="#E7E1F5"/>
            <path d="M13.154 15C12.8335 15 12.561 14.8878 12.3365 14.6635C12.1122 14.4392 12 14.1667 12 13.8462V1.15375C12 0.833251 12.1122 0.560834 12.3365 0.336501C12.561 0.112167 12.8335 0 13.154 0C13.4745 0 13.7469 0.112167 13.9712 0.336501C14.1956 0.560834 14.3078 0.833251 14.3078 1.15375V13.8462C14.3078 14.1667 14.1956 14.4392 13.9712 14.6635C13.7469 14.8878 13.4745 15 13.154 15Z" fill="#E7E1F5"/>
            <path d="M7.15375 15C6.83325 15 6.56083 14.8878 6.3365 14.6635C6.11217 14.4392 6 14.1668 6 13.8463V6.15375C6 5.83325 6.11217 5.56083 6.3365 5.3365C6.56083 5.11217 6.83325 5 7.15375 5C7.47425 5 7.74667 5.11217 7.971 5.3365C8.19533 5.56083 8.3075 5.83325 8.3075 6.15375V13.8463C8.3075 14.1668 8.19533 14.4392 7.971 14.6635C7.74667 14.8878 7.47425 15 7.15375 15Z" fill="#E7E1F5"/>
          </svg>
          <span style="font-size: 120%;justify-content:center; align-items:center; margin-left: 5px">
            Sin señal
          </span>
          `;
        }
        return signalText;
      } else {
        return `
        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.15375 15C0.83325 15 0.560834 14.8878 0.3365 14.6635C0.112167 14.4392 0 14.1667 0 13.8462V11.1538C0 10.8333 0.112167 10.5608 0.3365 10.3365C0.560834 10.1122 0.83325 10 1.15375 10C1.47425 10 1.74675 10.1122 1.97125 10.3365C2.19558 10.5608 2.30775 10.8333 2.30775 11.1538V13.8462C2.30775 14.1667 2.19558 14.4392 1.97125 14.6635C1.74675 14.8878 1.47425 15 1.15375 15Z" fill="#E7E1F5"/>
          <path d="M13.154 15C12.8335 15 12.561 14.8878 12.3365 14.6635C12.1122 14.4392 12 14.1667 12 13.8462V1.15375C12 0.833251 12.1122 0.560834 12.3365 0.336501C12.561 0.112167 12.8335 0 13.154 0C13.4745 0 13.7469 0.112167 13.9712 0.336501C14.1956 0.560834 14.3078 0.833251 14.3078 1.15375V13.8462C14.3078 14.1667 14.1956 14.4392 13.9712 14.6635C13.7469 14.8878 13.4745 15 13.154 15Z" fill="#E7E1F5"/>
          <path d="M7.15375 15C6.83325 15 6.56083 14.8878 6.3365 14.6635C6.11217 14.4392 6 14.1668 6 13.8463V6.15375C6 5.83325 6.11217 5.56083 6.3365 5.3365C6.56083 5.11217 6.83325 5 7.15375 5C7.47425 5 7.74667 5.11217 7.971 5.3365C8.19533 5.56083 8.3075 5.83325 8.3075 6.15375V13.8463C8.3075 14.1668 8.19533 14.4392 7.971 14.6635C7.74667 14.8878 7.47425 15 7.15375 15Z" fill="#E7E1F5"/>
        </svg>
        <span style="font-size: 120%;justify-content:center; align-items:center; margin-left: 5px">
          Sin señal
        </span>
        `;
      }
    },
    /**
     * Metodo que retorna la estructura html de un trip en una version que solo contiene el tipo y la calle.
     * @param {Trip} marker, es el punto del trip dentro del mapa.
     * @returns {String} estructura html de la ventana de info.
     */
    getSpotInfoWindowContentSimple: function (marker, color) {
      const spotTitle = marker.trip.typeName;
      const spotAddress = marker.trip.formattedStreet;
      console.log('markerEspecial', marker.trip.typeActivity);
      if (marker.trip.state != undefined) {
        color = '#804FF8';
        const type = marker.trip.type == 'DELIVERY' ? 'entrega' : 'retiro';
        return marker.trip.state != 'PLANNED'
          ? `<div class="card" style="height:auto; width:100%; minWidth:400px;border:0;">
                        <div class="card-content">
                          <div style="color: ${color}; min-width: 150px;" >
                            <span style="font-size: 110%;font-weight: bold;">
                              ${spotTitle}
                            </span>
                          </div>
                          <div class="content" style="color:#6c757d;">
                            <span style="color: #686868;font-weight:500">
                              <span style="font-size: 500;font-weight: bold;">
                                Coordenadas ${type}: 
                              </span>
                              ${marker.trip.coordinates.lat}, ${marker.trip.coordinates.lng}
                            </span>
                          </div>
                          <div class="content" style="color:#6c757d;">
                            <span style="color: #686868;font-weight:500">
                              <span style="font-size: 500;font-weight: bold;">
                                Fecha y hora ${type}: 
                              </span>
                              ${marker.trip.scheduled}
                            </span>
                          </div>
                        </div>
                    </div>
                </div>`
          : `<div class="card" style="height:auto; width:95%; minWidth:380px;border:0;">
                      <div class="card-content">
                        <div style="color: ${color}; min-width: 150px;" >
                          <span style="font-size: 110%;font-weight: bold;">
                            ${spotTitle}
                          </span>
                        </div>
                        <div class="content" style="color:#6c757d;">
                          <span style="color: #686868;font-weight:500">
                            ${spotAddress}
                          </span>
                        </div>
                      </div>
                  </div>
              </div>`;
      }

      return marker.trip.typeActivity == null
        ? `<div class="card" style="height:auto; width:95%; minWidth:380px;border:0;">
                      <div class="card-content">
                        <div style="fill: ${color}; min-width: 150px;" >
                          <svg xmlns="http://www.w3.org/2000/svg" height="25px" viewBox="0 0 36 32" width="25px">
                            <path d="M0 0h24v24H0z" fill="none" />
                            <path
                              d="M10.5,26 C17.5,19.3170648 21,14.0809537 21,10.2916667 C21,4.60773612 16.2989899,0 10.5,0 C4.70101013,0 0,4.60773612 0,10.2916667 C0,14.0809537 3.5,19.3170648 10.5,26 Z"
                            />
                          </svg>
                          <span style="font-size: 110%;font-weight: bold;">
                            ${spotTitle}
                          </span>
                        </div>
                        <div class="content" style="color:#6c757d;">
                          <span style="color: #686868;font-weight:500">
                            ${spotAddress}
                          </span>
                        </div>
                      </div>
                  </div>
              </div>`
        : `<div class="card" style="height:auto; width:95%; minWidth:380px;border:0;">
                      <div class="card-content">
                        <div style="fill: ${color}; min-width: 150px;" >
                          <svg xmlns="http://www.w3.org/2000/svg" height="25px" viewBox="0 0 36 32" width="25px">
                            <path d="M0 0h24v24H0z" fill="none" />
                            <path
                              d="M10.5,26 C17.5,19.3170648 21,14.0809537 21,10.2916667 C21,4.60773612 16.2989899,0 10.5,0 C4.70101013,0 0,4.60773612 0,10.2916667 C0,14.0809537 3.5,19.3170648 10.5,26 Z"
                            />
                          </svg>
                          <span style="font-size: 110%;font-weight: bold;">
                            ${spotTitle}
                          </span>
                        </div>
                        <div class="content" style="color:#6c757d;">
                          <span style="color: #686868;font-weight:500">
                            ${marker.trip.typeActivity == 'COLLECTION' ? 'Tipo retiro' : 'Tipo entrega'}
                          </span>
                        </div>
                        <div class="content" style="color:#6c757d;">
                          <span style="color: #686868;font-weight:500">
                            ${spotAddress}
                          </span>
                        </div>
                      </div>
                  </div>
              </div>`;
    },
    updateVehicleLocation(gapi, newLocations, selectedRoute) {
      if (this.usingVehicleMarker) {
        this.addRealTimeMarkers(gapi, newLocations, false);
      } else {
        if (this.actualPositionVeh != null) {
          const findMarker = newLocations.find(
            (vehLocation) => vehLocation.plate == this.actualPositionVeh.trip.typeName,
          );
          if (findMarker) {
            this.actualPositionVeh.setPosition({ lat: findMarker.lat, lng: findMarker.lon });
            this.actualPositionVeh.description = this.getVehicleInfoWindow(
              this.actualPositionVeh,
              this.actualPositionVeh.colorActive,
            );
            this.actualPositionVeh.setIcon({
              url: require('../assets/vehiculomorado.svg'),
              origin: new this.gapi.maps.Point(0, 0),
              anchor: new this.gapi.maps.Point(10.75, 25.75),
              scale: 1.2,
              labelOrigin: new this.gapi.maps.Point(0, 0),
            });
          }
        } else if (selectedRoute != null) {
          console.log(selectedRoute);
          const findMarker = newLocations.find(
            (vehLocation) => vehLocation.vehicleId == selectedRoute.resources[0].idVehicleOperaciones,
          );
          const indexMarker = newLocations.length + 3;
          const name = findMarker.plate;
          const lat = findMarker.lat;
          const lon = findMarker.lon;
          const hasRealLocation = false;
          //Si el marcador es bodega se pasa nulo debido a que el marcador es una imagen para las bodegas
          let colorIcon = this.markerColor(findMarker);
          const initMarker = this.prepareMarker(
            indexMarker,
            lat,
            lon,
            name,
            null,
            hasRealLocation,
            null,
            'Vehicle',
            findMarker.gpsData,
            null,
          );
          this.actualPositionVeh = this.setSvgMarker(
            initMarker,
            colorIcon,
            indexMarker,
            'Vehicle',
            findMarker.gpsData.cog,
            findMarker.state,
          );

          this.actualPositionVeh.setMap(this.map);
        }
      }
    },
    async addRealTimeMarkers(gapi, vehiclePoints, requireZoom) {
      this.usingVehicleMarker = true;
      //Se encarga de limpiar el cluster si es que existe
      this.cleanCluster();
      //Limpio marcadores de google
      this.cleanMapMarkers();
      //Limpio el spiderfier
      this.cleanMarkersFromSpiderfier();
      //Limpio rendereizados en el mapa
      this.setMapNull();
      //Seteo el api como variable global
      this.setGapi(gapi);
      await this.$refs.mapRef.$mapPromise.then((map) => {
        this.map = map;
        this.configureSpiderfier();
      });
      vehiclePoints.forEach((vehicle, index) => {
        const indexMarker = index + 1;
        const name = vehicle.plate;
        const lat = vehicle.lat;
        const lon = vehicle.lon;
        const hasRealLocation = false;
        //Si el marcador es bodega se pasa nulo debido a que el marcador es una imagen para las bodegas
        let colorIcon = this.markerColor(vehicle);
        const initMarker = this.prepareMarker(
          indexMarker,
          lat,
          lon,
          name,
          null,
          hasRealLocation,
          null,
          'Vehicle',
          vehicle.gpsData,
          null,
        );
        const svgMarker = this.setSvgMarker(
          initMarker,
          colorIcon,
          indexMarker,
          'Vehicle',
          vehicle.gpsData.cog,
          vehicle.state,
        );

        this.vehiclePositionMarker.push(svgMarker);
      });

      //Por cada viaje, se prepara un marker en mapa.
      if (this.vehiclePositionMarker.length >= 1) {
        this.oms.clearMarkers();
        let bounds = new gapi.maps.LatLngBounds();
        this.vehiclePositionMarker.forEach((marker) => {
          marker.setMap(this.map);
          const loc = new gapi.maps.LatLng(marker.position.lat(), marker.position.lng());
          this.oms.addMarker(marker);
          bounds.extend(loc);
        });
        if (requireZoom) {
          await this.$refs.mapRef.$mapPromise.then((map) => {
            map.fitBounds(bounds);
          });
        }
      }
      const customRenderer = {
        render: ({ count, position }) => {
          return new this.gapi.maps.Marker({
            label: { text: String(count), color: 'white', fontSize: '10px' },
            position,
            // adjust zIndex to be above other markers
            zIndex: Number(this.gapi.maps.Marker.MAX_ZINDEX) + count,
            icon: {
              url: require('../assets/cluster.svg'),
            },
          });
        },
      };
      this.markerCluster = new MarkerClusterer({
        markers: this.vehiclePositionMarker,
        map: this.map,
        renderer: customRenderer,
      });
    },
    /**
     * Metodo que construye la linea del recorrido del vehículo segun los points
     * Ademas indica la ubicacion y direccion del vehículo a traves de realTimePoint
     * @param {Array} points
     * @param {JSON} realTimePoint
     */
    async setMapRealTime(points, realTimePoint) {
      this.paths = [];

      if (this.paths.length == 0) {
        this.paths.push({
          draw: points,
          status: 'PENDING',
        });
      } else {
        this.paths[0].draw.push(points);
      }
      this.realTimeLocationVeh.push({
        position: {
          lat: realTimePoint.lat,
          lng: realTimePoint.lon,
        },
        svgMarker: {
          path: this.iconPathArrow,
          fillColor: '#000000',
          fillOpacity: 1,
          strokeWeight: 0,
          rotation: realTimePoint.gpsData.cog,
          origin: new this.gapi.maps.Point(0, 0),
          anchor: new this.gapi.maps.Point(10.75, 25.75),
          scale: 1.5,
        },
      });
    },
    /**
     * Metodo que añade puntos al recorrido del vehículo, ademas construye el nuevo marcador para el vehículo en su nueva posicion
     * @param {Array} points
     * @param {JSON} realTimePoint
     */
    addPointToRealTime(points, realTimePoint) {
      this.realTimeLocationVeh = [];
      this.realTimeLocationVeh.push({
        position: {
          lat: realTimePoint.lat,
          lng: realTimePoint.lon,
        },
        svgMarker: {
          path: this.iconPathArrow,
          fillColor: '#000000',
          fillOpacity: 1,
          strokeWeight: 0,
          rotation: realTimePoint.gpsData.cog,
          origin: new this.gapi.maps.Point(0, 0),
          anchor: new this.gapi.maps.Point(10.75, 25.75),
          scale: 1.5,
        },
      });
      if (this.paths.length == 0) {
        this.paths.push({
          draw: points,
          status: 'PENDING',
        });
      } else {
        this.paths[0].draw = points;
      }
    },
    /**
     * Metodo que construye el nuevo marcador para la carga en su nueva posicion
     * @param {Array} points
     * @param {JSON} realTimePoint
     */
    updateRealTimeCargo(realTimePoint) {
      this.realTimeLocationCargo = [];
      this.realTimeLocationCargo.push({
        zIndex: 100,
        position: {
          lat: realTimePoint.lat,
          lng: realTimePoint.lon,
        },
        svgMarker: {
          path: this.iconPathCargo,
          fillColor: '#000000',
          fillOpacity: 1,
          strokeWeight: 0,
          origin: new this.gapi.maps.Point(0, 0),
          anchor: new this.gapi.maps.Point(10.75, 25.75),
          scale: 1.5,
        },
      });
    },
    /**
     * Metodo que construye el nuevo marcador para el gps control en su nueva posicion
     * @param {Array} points
     * @param {JSON} realTimePoint
     */
    updateRealTimeGpsControl(realTimePoint) {
      this.realTimeLocationGpsControl = [];
      this.realTimeLocationGpsControl.push({
        zIndex: 100,
        position: {
          lat: realTimePoint.lat,
          lng: realTimePoint.lon,
        },
        svgMarker: {
          path: this.iconPathCargo,
          fillColor: '#000000',
          fillOpacity: 1,
          strokeWeight: 0,
          origin: new this.gapi.maps.Point(0, 0),
          anchor: new this.gapi.maps.Point(10.75, 25.75),
          scale: 1.5,
        },
      });
    },
    getSecurePathEventInfo() {
      try {
        let result = `${store.getters.urlAPI}/securePathEvent/filter?`;
        const config = {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
          },
        };
        if (this.route.id !== '-') {
          result += '&' + 'idRoute=' + this.route.id;
        }
        // result +=  '&' + 'idRoute=1776';
        let response = axios.get(result, config);
        return response;
      } catch (e) {
        console.log(e);
        return '';
      }
    },

    async outOfRouteMarkers(points) {
      points.forEach((point, index) => {
        this.markers.push({
          type: 'event',
          eventDate: point.eventDate,
          title: 'Evento salida de ruta',
          trip: point,
          index: String(index),
          position: { lat: point.lat, lng: point.lon },
          zIndex: index,
          soloMarker: true,
          colorActive: '#FF0000',
          colorInactive: '#FF0000',
          svgMarker: {
            path: this.icon.base,
            fillColor: '#FF0000',
            fillOpacity: 1,
            strokeWeight: 0,
            rotation: 0,
            origin: new this.gapi.maps.Point(0, 0),
            anchor: new this.gapi.maps.Point(10.75, 25.75),
            scale: 1.5,
          },
        });
      });

      const centerMap = await this.prepareMapView();
      await this.$refs.mapRef.$mapPromise.then((map) => {
        this.map = map;
      });

      //Edito el centro del mapa
      this.map.setCenter(centerMap);
      //Aplicar zoom
      await this.map.setZoom(15);
    },
    /** @author Nicolás Sepúlveda y Jorge Pizarro
     * Metodo que construye el mapa con las zonas de los spots
     * @param {Google api} gapi
     * @param {Array} trips
     * @param {Array} pointSelected
     * @param {Array} zones
     */
    async setMap(gapi, trips, pointSelected, zones) {
      let dataSecurePathEventInfo = await this.getSecurePathEventInfo();
      this.markers = [];
      if (this.renderer) {
        this.renderer.setMap(null);
      }
      await this.setGapi(gapi);
      //Se guardan los trips de manera local.
      await this.setMarkers(trips);

      const centerMap = pointSelected != null ? pointSelected : await this.prepareMapView();

      await this.$refs.mapRef.$mapPromise.then((map) => {
        this.map = map;
      });
      if (zones != null) {
        await this.setTrips(gapi, zones);
      }
      if (dataSecurePathEventInfo.data != '') {
        await this.outOfRouteMarkers(dataSecurePathEventInfo.data.data);
      }

      //Por cada viaje, se prepara un marker en mapa.
      if (this.markers.length > 1) {
        let bounds = new gapi.maps.LatLngBounds();
        this.markers.forEach((marker) => {
          var loc = new gapi.maps.LatLng(marker.position.lat, marker.position.lng);
          bounds.extend(loc);
        });
        await this.$refs.mapRef.$mapPromise.then((map) => {
          map.fitBounds(bounds);
        });
      }
      //Edito el centro del mapa
      this.map.setCenter(centerMap);
      //Si hay algun punto seleccionado aplica zoom al punto
      if (pointSelected != null) {
        this.map.setZoom(15);
      }
    },
    //*-----------------------------------------------------------------------------------------------------------------------*//

    //Para un futuro la documentacion utilizada para la api de direcciones y marcadores se encuentra en los siguientes links
    //https://developers.google.com/maps/documentation/javascript/reference/directions
    //https://developers.google.com/maps/documentation/javascript/reference/marker#MarkerOptions.icon

    //*-----------------------------------------------------------------------------------------------------------------------*//

    /**
     * Metodo que dibuja el mapa segun los puntos claves que uno le manda
     * @param {Google api} gapi
     * @param {Array} trips
     * @param {Array} waypoints
     * @param {Boolean} edit
     * @param {Integer} widthLine
     */
    async setMapWithPoints(gapi, trips, waypoints, edit, widthLine) {
      this.infoWinOpen = false;
      // Se realiza una limpieza de marcadores en el mapa para limpiar los existentes
      if (this.waypointsMarkers.length > 0) {
        this.waypointsMarkers.forEach((marker) => {
          marker.setMap(null);
        });
      }
      this.waypointsMarkers = [];
      this.markers = [];
      await this.setGapi(gapi);
      //Seteo los valores de los marcadores
      this.setMarkers(trips);

      const centerMap = await this.prepareMapView();

      await this.$refs.mapRef.$mapPromise.then((map) => {
        map.panTo(centerMap);
        map.setZoom(11);
        this.map = map;
      });
      let bounds = new gapi.maps.LatLngBounds();
      this.markers.forEach((marker) => {
        let loc = new gapi.maps.LatLng(marker.position.lat, marker.position.lng);
        bounds.extend(loc);
      });
      await this.$refs.mapRef.$mapPromise.then((map) => {
        map.fitBounds(bounds);
      });
      const requireIcon = false;
      const configStroke = {
        strokeColor: '#AD20CE',
        strokeOpacity: 0.8,
        strokeWeight: widthLine,
      };
      this.markers[0].waypoints = waypoints;
      this.preparePathInMapGoogle(this.markers, this.markers[0], 0, requireIcon, configStroke);
      this.markers[0].waypoints.forEach((wp) => {
        const waypointId = Date.now() + Math.random();
        wp.id = waypointId;
        const marker = this.buildWaypointMarker(wp.location.lat, wp.location.lng, edit);
        marker._waypointId = waypointId; // Asocia el id al marcador
        this.waypointsMarkers.push(marker);
        if (edit) {
          this.setDinamicWaypoints(marker, requireIcon, configStroke);
        }
      });

      // Para agregar un nuevo waypoint con click en el mapa
      if (edit) {
        this.map.addListener('click', (event) => {
          const waypointId = Date.now() + Math.random();
          this.markers[0].waypoints.push({
            id: waypointId,
            location: { lat: event.latLng.lat(), lng: event.latLng.lng() },
          });
          const marker = this.buildWaypointMarker(event.latLng.lat(), event.latLng.lng(), edit);
          marker._waypointId = waypointId; // Asocia el id al marcador
          this.waypointsMarkers.push(marker);
          //Como se añade un nuevo waypoint entonces se utiliza el ultimo indice del listado para acceder a el
          this.setDinamicWaypoints(marker, requireIcon, configStroke);
          this.preparePathInMapGoogle(this.markers, this.markers[0], 0, requireIcon, configStroke);
        });
      }
    },
    setDinamicWaypoints(marker, requireIcon, configStroke) {
      marker.addListener('dragend', (event) => {
        const wp = this.markers[0].waypoints.find((wp) => wp.id === marker._waypointId);
        if (wp) {
          wp.location.lat = event.latLng.lat();
          wp.location.lng = event.latLng.lng();
          this.preparePathInMapGoogle(this.markers, this.markers[0], 0, requireIcon, configStroke);
        }
      });

      // Puedes agregar aquí lógica para eliminar el waypoint (por ejemplo, con click derecho)
      marker.addListener('rightclick', () => {
        marker.setMap(null);
        // Elimina el marcador del array
        const markerIdx = this.waypointsMarkers.indexOf(marker);
        if (markerIdx > -1) {
          this.waypointsMarkers.splice(markerIdx, 1);
        }
        // Elimina el waypoint usando el id
        if (Array.isArray(this.markers[0].waypoints)) {
          const wpIdx = this.markers[0].waypoints.findIndex((wp) => wp.id === marker._waypointId);
          if (wpIdx > -1) {
            this.markers[0].waypoints.splice(wpIdx, 1);
          }
        }
        this.preparePathInMapGoogle(this.markers, this.markers[0], 0, requireIcon, configStroke);
        marker.setMap(null);
      });
    },
    buildWaypointMarker(lat, lng, edit) {
      const marker = new this.gapi.maps.Marker({
        position: { lat: lat, lng: lng },
        map: this.map,
        draggable: edit,
        label: '',
      });
      marker.setIcon({
        path: this.gapi.maps.SymbolPath.CIRCLE,
        scale: 5,
        fillColor: '#FFFFFF',
        fillOpacity: 1,
        strokeColor: '#000000',
        strokeWeight: 2,
      });
      return marker;
    },
    //Metodo que dibuja la ruta si hay waypoints, si hay algun fallo en ella mostrara un error
    async displayRouteWithPoints(origin, destination, waypoints, service, display, nameOrigin, nameDestination) {
      const timeDelayWhenFailed = 2000;
      const timeDelay = 100;
      await new Promise((resolve) => setTimeout(resolve, timeDelay));
      await service
        .route({
          origin: origin,
          destination: destination,
          waypoints: waypoints,
          travelMode: this.gapi.maps.TravelMode.DRIVING,
        })
        .then((result) => {
          display.setDirections(result);
          this.directionsRenderer.push(display);
          this.tries = 0;
        })
        .catch(async (e) => {
          if (e.code == 'ZERO_RESULTS') {
            showAlert(
              'Error',
              this.t('common.notification.errors.mapZeroPoints', { origin: nameOrigin, destination: nameDestination }),
            );
          } else if (e.code == 'MAX_WAYPOINTS_EXCEEDED') {
            showAlert('Error', this.t('common.notification.errors.mapMaxPoints'));
          } else if (e.code == 'OVER_QUERY_LIMIT') {
            if (this.tries < 30) {
              await new Promise((resolve) => setTimeout(resolve, timeDelayWhenFailed)); //Espera X segundos antes de un nuevo intento.
              this.displayRouteWithPoints(
                origin,
                destination,
                waypoints,
                service,
                display,
                nameOrigin,
                nameDestination,
              );
              this.tries += 1;
            }
          } else {
            showAlert(
              'Error',
              this.t('common.notification.errors.genericError', { origin: nameOrigin, destination: nameDestination }),
            );
          }
        });
    },
    //Entrega los puntos de la ruta
    getDirections() {
      let points = [];
      this.drawnPolylines.forEach((polyline) => {
        const pathArray = polyline.getPath();
        for (let i = 0; i < pathArray.getLength(); i++) {
          const latLng = pathArray.getAt(i);
          // Evita duplicados consecutivos
          if (
            points.length === 0 ||
            points[points.length - 1].lat !== latLng.lat() ||
            points[points.length - 1].lon !== latLng.lng()
          ) {
            points.push({
              lat: latLng.lat(),
              lon: latLng.lng(),
            });
          }
        }
      });
      return points;
    },
    //Entrega los puntos claves/Waypoints de la ruta
    getWaypoints() {
      return this.markers[0].waypoints;
    },
    //Vacia el mapa
    setMapNull() {
      if (this.renderer) {
        this.markers = [];
        this.directionsRenderer.forEach((directionRenderer) => {
          directionRenderer.setMap(null);
        });
        this.markersLastmileLite = [];
        this.directionsRenderer = [];
        this.renderer.setMap(null);
      }
      if (this.geoFencePoints.length > 0) {
        this.geoFencePoints.forEach((geoZone) => {
          geoZone.setMap(null);
        });
      }
    },
    enablePolyline(polylineEnabled) {
      this.usePolyline = polylineEnabled;
    },
    enableRealTimeMarker(markerEnabled) {
      this.useRealTimeMarker = markerEnabled;
    },
    enableRealTimeMarkerCargo(markerEnabled) {
      this.useRealTimeMarkerCargo = markerEnabled;
    },
    enableRealTimeMarkerGpsControl(markerEnabled) {
      this.useRealTimeMarkerGpsControl = markerEnabled;
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que retorna el centro del mapa dependiendo de los markers en mapa.
     * @returns {Object} position (lat/lng) para setear el mapa.
     */
    prepareMapView(lastmileLite) {
      if (lastmileLite == null) {
        if (this.markers.length === 1) {
          //Si el mapa solo tiene un punto, se retorna la posicion de dicho punto.
          return this.markers[0].position;
        } else if (this.markers.length === 2) {
          //Si el mapa tiene 2 puntos, se retorna el punto medio entre ambas.
          return {
            lat: (this.markers[0].position.lat + this.markers[1].position.lat) / 2,
            lng: (this.markers[0].position.lng + this.markers[1].position.lng) / 2,
          };
        } else {
          //Si el mapa tiene 3 o mas puntos, se realiza el calculo con MIN y MAX.
          let latLowest = 99999999999999999999;
          let latHighest = -99999999999999999999;

          let lngLowest = 99999999999999999999;
          let lngHighest = -99999999999999999999;

          this.markers.forEach((marker) => {
            if (marker.position.lat < latLowest) {
              latLowest = marker.position.lat;
            }

            if (marker.position.lat > latHighest) {
              latHighest = marker.position.lat;
            }

            if (marker.position.lng < lngLowest) {
              lngLowest = marker.position.lng;
            }

            if (marker.position.lng > lngHighest) {
              lngHighest = marker.position.lng;
            }
          });
          let retLat = latLowest + (latHighest - latLowest);
          let retLong = lngLowest + (lngHighest - lngLowest);
          console.log('latlong', retLat + '   ' + retLong);
          return {
            lat: latLowest + (latHighest - latLowest) / 2,
            lng: lngLowest + (lngHighest - lngLowest) / 2,
          };
        }
      } else {
        if (this.markersLastmileLite.length === 1) {
          //Si el mapa solo tiene un punto, se retorna la posicion de dicho punto.
          return this.markersLastmileLite[0].position;
        } else if (this.markersLastmileLite.length === 2) {
          //Si el mapa tiene 2 puntos, se retorna el punto medio entre ambas.
          return {
            lat: (this.markersLastmileLite[0].position.lat + this.markersLastmileLite[1].position.lat) / 2,
            lng: (this.markersLastmileLite[0].position.lng + this.markersLastmileLite[1].position.lng) / 2,
          };
        } else {
          //Si el mapa tiene 3 o mas puntos, se realiza el calculo con MIN y MAX.
          let latLowest = 99999999999999999999;
          let latHighest = -99999999999999999999;

          let lngLowest = 99999999999999999999;
          let lngHighest = -99999999999999999999;

          this.markersLastmileLite.forEach((marker) => {
            if (marker.position.lat < latLowest) {
              latLowest = marker.position.lat;
            }

            if (marker.position.lat > latHighest) {
              latHighest = marker.position.lat;
            }

            if (marker.position.lng < lngLowest) {
              lngLowest = marker.position.lng;
            }

            if (marker.position.lng > lngHighest) {
              lngHighest = marker.position.lng;
            }
          });
          let retLat = latLowest + (latHighest - latLowest);
          let retLong = lngLowest + (lngHighest - lngLowest);
          console.log('latlong', retLat + '   ' + retLong);
          return {
            lat: latLowest + (latHighest - latLowest) / 2,
            lng: lngLowest + (lngHighest - lngLowest) / 2,
          };
        }
      }
    },
    prepareMapViewGoogle(markersList) {
      if (markersList.length === 1) {
        //Si el mapa solo tiene un punto, se retorna la posicion de dicho punto.
        return markersList[0].position;
      } else if (markersList.length === 2) {
        //Si el mapa tiene 2 puntos, se retorna el punto medio entre ambas.
        return {
          lat: (markersList[0].position.lat() + markersList[1].position.lat()) / 2,
          lng: (markersList[0].position.lng() + markersList[1].position.lng()) / 2,
        };
      } else {
        //Si el mapa tiene 3 o mas puntos, se realiza el calculo con MIN y MAX.
        let latLowest = 99999999999999999999;
        let latHighest = -99999999999999999999;

        let lngLowest = 99999999999999999999;
        let lngHighest = -99999999999999999999;

        markersList.forEach((marker) => {
          if (marker.position.lat() < latLowest) {
            latLowest = marker.position.lat();
          }

          if (marker.position.lat() > latHighest) {
            latHighest = marker.position.lat();
          }

          if (marker.position.lng() < lngLowest) {
            lngLowest = marker.position.lng();
          }

          if (marker.position.lng() > lngHighest) {
            lngHighest = marker.position.lng();
          }
        });
        let retLat = latLowest + (latHighest - latLowest);
        let retLong = lngLowest + (lngHighest - lngLowest);
        console.log('latlong', retLat + '   ' + retLong);
        return {
          lat: latLowest + (latHighest - latLowest) / 2,
          lng: lngLowest + (lngHighest - lngLowest) / 2,
        };
      }
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que importa el objeto al componente.
     * @param {Object} gapi
     */
    setGapi(gapi) {
      this.gapi = gapi;
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que permite interactuar con los .json de las traducciones.
     * @param {String} key, es el elemento del .json a utilizar.
     * @param {String} value, es la variable a insertar (en caso de que el elemento lo solicite).
     * @returns el resultado de la traduccion.
     */
    t(key, value) {
      return i18n.t(key, value);
    },
  },
};
